
$.fn.outerHTML = function (s) {
    return s
        ? this.before(s).remove()
        : $("<p>").append(this.eq(0).clone()).html();
};


function DC() { this.dttTasks = null; }
DC.prototype = new vcTemplate();

DC.prototype.prepareSaveDialog = function () { return false; };
DC.prototype.dismissChanges = function () { return false; };

DC.prototype.saveDialog = function () {
    /// <summary>
    /// This function opens a modal dialog for saving data.<br/>                                                                     
    /// </summary>
    var me = this;
    try {
        //optional stuff done before the saving
        //set in the accoring inherited classes
        me.prepareSaveDialog();

        var dialog = $('<p>' + me.resources.saveChanges + '</p>').dialog({
            title: me.resources.saveDialogTitle, modal: true,
            buttons: {
                "Yes": function () {me.save();dialog.dialog('close');},
                "No": function () { me.dismissChanges();dialog.dialog('close');},
                "Cancel": function () { dialog.dialog('close'); return false;}
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('saveDialog', ex);return false;}
};

DC.prototype.showMessage = function (content, bError) {
    /// <summary>
    /// This function handles the error message handling.<br/>
    ///  Gets overwritten in DCEdit and DCMultipleValues 
    /// </summary>
    var me = this;
    try {

      

        if (bError === false) { console.info('got Log: ' + content);}
        if (bError) {
           
            me.error = true;
            me.visual.find('#divInfo').show();

            me.visual.find('#divInfo div').removeClass('note').addClass('error');
            content = "<span class='main'>" + content + "</span><br/><span class='sub'>" + me.resources.err_sub + "</span>";
            me.visual.find('#divInfo div').html(content);
            me.visual.find('#btnReload').hide();
        }
        return false;
    } catch (ex) { writeError('DC.showMessage', ex);return false;}
};

DC.prototype.writeError = function (source, ex) {
    var me = this;
    try {
      
        console.info(ex);
        me.error = true;
        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};


function DCOverview() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.Overview.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 1.4.2015<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 2.8.2017                                                *<br />
    /// **********************************************************************<br />
    /// * - refactored menu and loading functionality                        *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 19.4.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.blid = -1;
    this.dttInvalidArchive = null;
    this.showPlausReminders = true;
    this.pauseTimer = false;
    this.clearTimer = false;
    this.activity = true;
    this.timerDefaultDuration = 30;
    this.timerDuration = 0;
    this.contentHeight=0;
} 
DCOverview.prototype = new DC();

DCOverview.prototype.doEvent = function (event) {
  var me = this;
  
    try {
     
  if (event.vcgid===me.vcgid) {
    switch (event.msg) {
      case 'FETCH_ALL':me.fetchSignals(event.values);break;
      case 'SINGLE_EDIT_DAY':me.editDay(event.values, 1);break;
      case 'COPY_DAY':me.editDay(event.values, 2);break;
        case 'GET_INFO': me.getInfo(event.values); break;
        case 'UPDATE_STATE': me.updateState(); break;
            
      default: break;
    }
      } 
    
    switch (event.msg) {
      case 'MANUAL_EDIT_DAY':me.editDay(event.values, 0);break;
        case 'DATA_STATE_INVALIDARCHIVE_PERDAY': me.dttInvalidArchive = event.values; me.updateState(); break;
        case 'DATA_STATE_CURRENT_PLAUSLIST': me.setCurrentPlausList(event.values); break;
        case 'DATA_STATE_CURRENT_AUTOCHECK': me.setCurrentAutoCheck(event.values); break;
        case 'SET_EDIT_DAY': me.setNewEditDay(event.values); break;
        case 'SHOW_PLAUS_REMINDER': me.showPlausReminders = event.values; break;
        case 'UNITSTATUS': me.setUnitStatus(event.values); break;
        case 'LONGTERMVALIDATION': me.setLongTermStatus(event.values); break;

        case "OPEN_SELECTED_PROJECT":
            
            me.closeDetailForm();
            _VCMQ.produce(me.visual, me.vcgid, 'GET_INFO', { 'loggerid': event.values.id, 'day': event.values.day});
      default: break;
  }
      return false;
  } catch (ex) {me.writeError('doEvent', ex);return false;}
}; 

DCOverview.prototype.initOverview = function () {
  var me = this;
  try {
     
      me.contentHeight = parseInt(window._iBrowserHeight - ($("#header").height() + me.visual.find("#div-settings").height() + me.visual.find("#div-menu").height() + me.visual.find(".filter").height() + 25));
      
      me.visual.find("#contentList").height(me.contentHeight);
      me.visual.find("#divEditDayChart").height(parseInt(window._iBrowserHeight - ($("#header").height() + me.visual.find("#divEditDayHeader").height() + 60)));

     

      me.visual.find("#div-cal-overview").vcDate({ mode: "Range", align: "right", "defaultRange": { from: me.filterStart, to: me.today }, interval: 1, langID: me.UserLangIDForCulture});

      me.initIntervalCalendar(me.visual.find('#txtDateOverviewStart'), me.visual.find('#txtDateOverviewEnd'), 'minDate');
       me.initIntervalCalendar(me.visual.find('#txtDateOverviewEnd'), me.visual.find('#txtDateOverviewStart'), 'maxDate');

      me.visual.find("#div-menu .button-toggle").button();


      me.visual.find('#div-menu .button-toggle').off('click').on('click',function() { me.initMenuHandler($(this)); });

      me.visual.find('#div-archive-types .types').off('click').on('click', function () {
          me.activity = true;
          if ($(this).hasClass("active")) {
                  $(this).removeClass("active");
              } else {
                  $(this).addClass("active");
          }
       if ($(this).attr("id") === "btn-reminder") { me.filter();};});

      me.fetchArchive();
      me.visual.find("#div-counter").html(me.timerDefaultDuration);
      
      me.setTimer();


    //show/hide a logger group
      me.visual.find('.manageGroup').off('click').on('click',function() { 
       var id = $(this).attr('id');
       id = id.replace('manageGroup','');
       if (me.visual.find('#manage'+id).is(':visible') === true) {
         me.visual.find('#manage'+id).hide();
         $(this).find('.fa').removeClass('fa-minus-square').addClass('fa-plus-square');
       } else {
         me.visual.find('#manage'+id).show();
         $(this).find('.fa').removeClass('fa-plus-square').addClass('fa-minus-square');
       }
     });
    //init the back button if the editDay form
      me.visual.find('#btnBackEditDay').button().off('click').on('click',function() {
          me.closeDetailForm();
      });

      //init the back button if the editDay form
      me.visual.find('#btnChangeDataManageTypeID').button().off('click').on('click', function () {
          me.changeDataManageTypeID();
      });

     // //inits the ignore rules button 
      me.visual.find('#chbIgnoreRules').off('click').on('click', function () {
          if ($(this).prop("checked") === false) {
              me.visual.find("#divIgnoreRules").removeClass("error").addClass("note");
              return true;
          } else {
              me.visual.find("#divIgnoreRules").removeClass("note").addClass("error");
              return true;
          }
      });

      // inits the checkbox for starting the DC in archive mode or not
      me.visual.find('#chbMultipleDC').off('click').on('click', function () {
          if ($(this).prop("checked") === false) {
              me.visual.find("#divMultipleDC").removeClass("note").addClass("error");              
              return true;
          } else {
              me.visual.find("#divMultipleDC").removeClass("error").addClass("note");
              return true;
          }
      });

      //init the filter 
     me.visual.find("#div-overview-filter").vcFilter({parameter:"", callback: function () { me.filter() } });

      //init the date picker for the start date
     me.visual.find('#txtFilterStart').datepicker({
       changeMonth: true,changeYear: true,showButtonPanel: true,showOn: 'button',buttonImage: '../../images/visualcore/calendar.gif',buttonImageOnly: true
     });

      // //inits the ignore rules button 
      me.visual.find('#span-set-logger').off('click').on('click', function () { $("<div>").vcSetLogger({ blid: me.blid }); });

      return false;
  } catch (ex) { me.writeError('initOverview', ex); return false;}
};

DCOverview.prototype.closeDetailForm = function () {
    var me = this;
    try {
        me.blid = -1;
        me.visual.find('#divEditDay').hide();
        me.visual.find('#divEditDay #divEditPlaus').html("");
        me.visual.find('#divOverview').show();
        return false;
    } catch (ex) { me.writeError('closeDetailForm', ex); return false; }
};

DCOverview.prototype.setTimer = function() {
    var me = this;
    try {
    setTimeout(function () {

        if (me.error) { return false; }
        if (me.clearTimer) {
            me.activity = true;
            me.pauseTimer = false;
            me.visual.find("#div-counter").html(1);
            me.clearTimer = false;
        } 
        

        if (me.pauseTimer === false) {
            if (me.visual.find("#contentList").is(":visible")) {
                var counter = parseInt(me.visual.find("#div-counter").html(), 10);
                counter--;
                me.visual.find("#div-counter").html(counter);

                if (counter === 0) {
                  
                    me.fetchArchive();
                    if (me.activity === false) {
                        me.timerDuration += 15;
                    } else {
                        me.timerDuration = 0;
                    }
                    me.visual.find("#div-counter").html(me.timerDefaultDuration + me.timerDuration);
                    me.activity = false;
                }

            } else {
                me.activity = true;
            }
        } else {
            me.activity = true;
        }
        
        me.setTimer();
        return true;
    }, 1000);
    return true;
    } catch (ex) { me.writeError('setTimer', ex); return false; }
}

DCOverview.prototype.initMenuHandler = function (obj) {
    /// <summary>
    ///  This function opens a visual based on the selected menu point in the details. 
    /// </summary>
    var me = this;
    var type;
    var visual;
    var h;
    var w;
    var param;
    var signalParam;
    var showVisual = false;
  
    try {
        if (me.error) { return false; }

        me.visual.find("#div-menu .button-toggle").removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");
        //get the type of the currently active button
        type = obj.data("type");
        param = "";
        signalParam = "";
        visual = "";

        h = me.contentHeight + 40;
        me.visual.find("#div-menu-content").show();
        w = parseInt($("#div-menu-content").width() - 20, 10);


        switch (type) {
            case "longterm":
                me.pauseTimer = true;
                
                showVisual = true;
                visual = "VISUAL_ALARMHISTORY";
                param = JSON.stringify({ "ShowLongTermValidationOnly": true, "FixedContentHeight":true });
                break;
            case "devices":
                me.pauseTimer = true;
                visual = 'VISUAL_UNITSTATUS';
                showVisual = true;
              
                break;
            case "autocheck":
                me.pauseTimer = true;
                visual = '';
                showVisual = true;

                break;
            case "archive":
                me.clearTimer = true;
                showVisual = false;
                me.visual.find("#div-archive-types").show();
                break;
            case "missing":
                me.clearTimer = true;
                showVisual = false;
                me.visual.find("#div-archive-types").hide();
                break;
            default:
        }
       

        if (showVisual) {
            //h = parseInt($("#div-menu-content").height(), 10) + 40;
        
            //we generate a random sub container every time 
            var container = me.getRandomIDContainerObj("div-menu-content-", true);
            me.visual.find("#div-menu-content").html(container.obj);
            me.visual.find(".filter, #contentList").hide();
            me.visual.find("#div-menu-content").show();

            if (type !== "autocheck") {
                me.vcVisual.addVisualBaseByName("div-menu-content-", visual, container.random, getCurrentTimestamp(), h, w, param, signalParam, 1);
            } else {
             
                container.obj.height(h);
                container.obj.width(w);
                container.obj.AutoCheckOverview({ invokeType: "addVisualBase" });
            }
         
        } else {
            me.visual.find(".filter, #contentList").show();
            me.visual.find("#div-menu-content").hide();
        }





            return true;

    } catch (ex) { me.writeError('initMenuHandler', ex); return false }

}

DCOverview.prototype.initListClickHandler = function () {
  var me = this;
    try {


      //inits the button for sending tasks
      //me.visual.find('.days .btnFetch,.days .counter').off('click').on('click',function() { 
      // var blid = $(this).parents('.blid').attr('id');
      // blid = parseInt(blid.replace('blid',''),10);
      // var dt = $(this).siblings('.dt').html();
      // //get the current counter and increase it by 1 and set the day to dirty
      // var counter = 0;
      // if (me.visual.find('#day' + blid + '_' + dt.replace(/\./g,'')).html().length>0) {
      //     counter = parseInt(me.visual.find('#day' + blid + '_' + dt.replace(/\./g, ''), 10).html());
      // }
      // counter++;
      // me.visual.find('#day' + blid + '_' + dt.replace(/\./g,'')).html(counter).show();
      // $(this).parents('.day').addClass('daydirty');
      // $(this).off('click');
      // //send fetch event
      // _VCMQ.produce(me.visual, me.vcgid, 'FETCH_ALL', {'loggerid':blid, 'day':dt});
      //});
      //inits the info button 
      me.visual.find('.day').off('click').on('click',function() { 
       var blid = $(this).parents('.blid').attr('id');
       blid = parseInt(blid.replace('blid', ''), 10);
       var dt = $(this).find('.dt').html();
      
       _VCMQ.produce(me.visual, me.vcgid, 'GET_INFO', { 'loggerid': blid, 'day': dt });
      });

        //inits the signal tree clicked from the plaus list 
      me.visual.find('.plaus-overview').off('click').on('click', function () {
          var dt = getCurrentTimestamp();
          dt = dt.substring(0, 10);

          _VCMQ.produce(me.visual, me.vcgid, 'GET_INFO', { 'loggerid': parseInt($(this).data('blid'), 10), 'day':  dt });
      });

        //inits the signal tree clicked from the plaus list 
        me.visual.find('.auto-check-state').off('click').on('click', function () {
            me.showAutoCheckPopup(parseInt($(this).data('blid')));
            //_VCMQ.produce(me.visual, me.vcgid, 'GET_INFO', { 'loggerid': parseInt($(this).data('blid'), 10), 'day': dt });
        });

   

      ////init the button for showing the edit form
      //me.visual.find('.days .btnEditDay').off('click').on('click',function() { 
      // var blid = $(this).parents('.blid').attr('id');
      // me.blid = parseInt(blid.replace('blid', ''), 10);
      // me.day = $(this).siblings('.dt').html();

      // _VCMQ.produce(me.visual, me.vcgid, 'MANUAL_EDIT_DAY', {'loggerid':me.blid, 'day':me.day});
      //});


        //init the button for showing the edit form
      me.visual.find('.btnEditDayLogger, .loggerName').not(".popup").off('click').on('click', function (e) {
        var blid = $(this).parents('.blid').attr('id');
          me.blid = parseInt(blid.replace('blid', ''), 10);

       
        _VCMQ.produce(me.visual,
            me.vcgid, 'MANUAL_EDIT_DAY',{ 'loggerid': me.blid, 'day': me.today, 'ShowErrorsOnly': false });
        e.stopPropagation();
      });



        //click handler for the signal info popup
      me.visual.find('#contentList').off('click', ".popup").on('click', ".popup", function (e) {
          me.vcVisual.showProjectSummaryDialog(parseInt($(this).data("id"), 10));
          e.stopPropagation();
      });


      me.visual.find('#divBtnFilterProjects').off('click').on('click', function () {
          $(this).toggleClass("button-toggle-active");
          me.filter();
      });


    return false;
} catch (ex) { me.writeError('initListClickHandler', ex); return false;} 
};  

DCOverview.prototype.fetchArchive = function () {
    var me = this;
    var param;
    var dates;
    try {

        if (me.error) {
            return false;
        }

        dates = me.visual.find('#div-cal-overview').vcDate('getDate');
       
        if (me.visual.find("#btn-missing").hasClass("button-toggle-active")) {
            param = {
                'filterstart': dates.from,
                'filterEnd': dates.to,
                'ShowInvalid': false,
                'ShowInplausible': false,
                'ShowMissing': true,
                'ShowPlausibilities': false,
                'ShowAutoCheck': false
               
            };
            me.visual.find("#btn-missing .div-loading img").show();
            me.visual.find(".plaus-overview").html("");
        } else {
            param = {
                'filterstart': dates.from,
                'filterEnd':dates.to,
                'ShowInvalid': me.visual.find("#btn-invalid").hasClass("active"),
                'ShowInplausible': me.visual.find("#btn-inplausible").hasClass("active"),
                'ShowMissing': false,
                'ShowPlausibilities': true,
                'ShowAutoCheck': true,
                'filterBlids': []
            };
            me.visual.find("#btn-archive .div-loading img").show();



        }
        me.visual.find(".plaus-overview").html("").removeClass("err");

        param.ShowRules = me.visual.find("#chbIgnoreRules").prop("checked") === false;

        // check if we have a filter and add the found blids to the parameter list;
        // we then search only for the filtered blids in the db
        // workaround to get errors for e.g. only 1 project -> huge time interval is then possible
        if (me.visual.find("#div-overview-filter").data("bluaul-vcFilter") !== undefined) {
            var txt = me.visual.find("#div-overview-filter").vcFilter("getFilter");
            if (txt !== null) {
                var found = me.visual.find('.blid.found');

                var idArray = [];

                found.each(function () {
                    var fullId = $(this).attr("id");
                    if (fullId && fullId.startsWith("blid")) {
                        var id = parseInt(fullId.replace("blid", ""), 10);
                        if (!isNaN(id)) {
                            idArray.push(id);
                        }
                    }
                });

                param.filterBlids = idArray;
            }
        }        
        

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
            function (result) {

                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                if (result.Archive == null) { return false; }

                if (result.Archive.length>0) {
                    _VCMQ.produce(me.visual, me.vcgid, 'DATA_STATE_INVALIDARCHIVE_PERDAY', result.Archive);
                  
                } else {
                    me.visual.find("#btn-archive .div-status").html("");
                    me.initListClickHandler();
                   
                }


                if (result.Plausibility.rows != null) {
                    setTimeout(function () {
                        _VCMQ.produce(me.visual, me.vcgid, 'DATA_STATE_CURRENT_PLAUSLIST', result.Plausibility);
                    }, 2000);
                } else {
                    me.visual.find(".plaus-overview").html("");
                }
                if (result.AutoCheck.rows != null) {
                    setTimeout(function () {
                        _VCMQ.produce(me.visual, me.vcgid, 'DATA_STATE_CURRENT_AUTOCHECK', result.AutoCheck);
                    }, 1000);
                } else {
                    me.visual.find(".auto-check-state").html("");
                }

                // sTmp += "    $('#divAPArchiveErrors').html(sum);"
                if (result.RulesBuffer.rows != null) {
                    $('#divAPAnalogBufferRules').html(result.RulesBuffer.rows[0].count);
                }
                if (result.AnalogBuffer.rows != null) {
                    $('#divAPAnalogBuffer').html(result.AnalogBuffer.rows[0].count);
                }

                if (result.Archive != null) {
                    var sum = 0;
                    var missing = 0;
                    var inplaus = 0;
                    var sTmp;

                    for (let group of result.Archive) {
                        for (let day of group.Days) {
                            sum += day.Entries[0].V;
                            inplaus += day.Entries[0].P;
                            missing += day.Entries[0].E;
                        }
                    }


                    if (me.visual.find("#btn-missing").hasClass("button-toggle-active")) {
                        if (missing > 0) {
                            me.visual.find("#btn-missing .div-status")
                                .html("<span class='icon-color-error'>" + missing + " </span>");
                        } else {
                            me.visual.find("#btn-missing .div-status").html("");
                        }
                    } else {

                        if (sum > 0) {
                            sTmp = "<span class='icon-color-error'>" +
                                sum +
                                "   <i class='fa-regular fa-times-circle' ></i></span>";
                        } else {
                            sTmp = "";
                        }
                        $('#divAPArchiveErrors').html(sum);
                        if (inplaus > 0) {
                            if (sTmp.length > 0) {
                                sTmp += " | ";
                            }
                            sTmp += "<span class='icon-color-error'>" +
                                inplaus +
                                "   <i class='fa-regular fa-exclamation-triangle' ></i></span>";
                        }
                        me.visual.find("#btn-archive .div-status").html(sTmp);
                    }
                } else {
                    me.visual.find('.blid').data("invalid", "").removeClass("found");
                    me.visual.find('.blid .days').html('');
                    me.filter();
                }
                me.visual.find("#div-menu .div-loading img").hide();

                return false;
            });
        return false;
    } catch (ex) {
        me.writeError('fetchArchive', ex);
        return false;
    }
};

DCOverview.prototype.updateState = function () {
  var me = this;
  var sTmp = '';

  try {
    var data = me.dttInvalidArchive;


      if (data === null) {
          me.initListClickHandler();
          return false;
      }


        me.visual.find('.blid').data("invalid", "");
        var dt; 
        //store values of existing days into a temporary list
        var dayList =  me.visual.find('.counter').filter(function() { return $(this).html().length > 0; });
            //delete all existing days
      me.visual.find('.blid .days').html('');
    

      // Richtige Iteration über die Datenstruktur
      for (const group of data) {
          // group ist hier ein AqsGroup-Objekt, z.B. { Blid: 101, Days: [...] }
          //console.log("Processing Group - Blid: " + group.Blid);

          for (const day of group.Days) {
              // day ist ein AqsDays-Objekt, z.B. { Day: "2026-02-16T00:00:00", Entries: [...] }
              dt = $.datepicker.formatDate('dd.mm.yy', new Date(day.Day));

              let invalidCount = day.Entries[0].V;
              let inplausibleCount = day.Entries[0].P;
              let missingCount = day.Entries[0].E;

              // Hier können Sie die aggregierten Werte verwenden, um Ihr HTML zu erstellen
              let totalErrors = invalidCount + inplausibleCount + missingCount;
              //console.log("Processing Group - Blid: " + group.Blid + " Day: " + dt + " total: " + totalErrors);
             
              if (totalErrors > 0) {
                  me.visual.find('#blid' + group.Blid).data("invalid", totalErrors);
                  //alert();
                  sTmp = "<div class='day' data-error='" + invalidCount + "' data-inplaus='" + inplausibleCount + "' data-missing='" + missingCount + "'>";
                  sTmp += "<span class='dt'>" + dt + "</span>";
                  sTmp += "<span id='day" + group.Blid + "_" + $.datepicker.formatDate('ddmmyy', new Date(day.Day)) + "' class='counter'></span>";
                  sTmp += "<div class='errors'>";

           
                  if (day.Entries[0].E > 0) {
                      sTmp += day.Entries[0].E;
                  } else {
                      sTmp += invalidCount + "/" + inplausibleCount;
                  }
                  sTmp += "</div>";
                  sTmp += "</div>";
                 
                  me.visual.find('#blid' + group.Blid + ' .days').append(sTmp);
                  me.visual.find('#blid' + group.Blid).show();
               
              }
          }
          //update the counter from the temporary list
                  dayList.each(function () {
                      me.visual.find('#' + $(this).attr('id')).html($(this).html()).parents('.day').addClass('dayedited');
                  });
      }
           dayList=null;dt=null;
      
       
          //hide all entries which are visible but have no invalid archive entries anymore
           me.filter();


      me.initListClickHandler();
      return false;
  } catch (ex) { me.writeError('updateState', ex); return false;} 
};  

DCOverview.prototype.filter = function () {
    var me = this;
    var filter;
    var i;
    try {

 
        //first, remove the 'found' class of all loggers
        me.visual.find(".blid").removeClass('found').data("counter", 0);

        filter = me.visual.find("#div-overview-filter").vcFilter("getFilter");


        if (me.visual.find("#divBtnFilterProjects").hasClass("button-toggle-active") && filter === null) {
            me.visual.find(".blid").addClass('found');
            //now, we filter the optional tags we got from the vc-tags
        } else {
            if (filter !== null) {

                var counter;
                //first, we count how often we find the filter tags in every signal item
                for (i = 0; i <= filter.length - 1; i++) {
                    if (filter[i].length > 0) {
                        me.visual.find(".blid:contains('" + filter[i] + "')")
                            .each(function() {
                                counter = parseInt($(this).data('counter'), 10) + 1;
                                $(this).data('counter', counter);
                            });
                    }
                }
                //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
                //why? if we have several filter tags we have to find all of them in one single signal 
                me.visual.find(".blid").each(function() {
                    if (parseInt($(this).data("counter"), 10) === filter.length) {
                        $(this).addClass("found");
                    }
                });
            } else {


                me.visual.find(".blid").addClass("found");
                me.visual.find('.blid').filter(function() { return $(this).data('invalid').length === 0; })
                    .removeClass("found");
                if (me.showPlausReminders) {
                    me.visual.find('.blid').filter(function() { return $(this).find('.fa-bell').length > 0; })
                        .addClass("found");
                }
            }

        }
   

        if (me.visual.find("#btn-reminder").hasClass("active")) {
            me.visual.find('.blid').filter(function() { return $(this).find('.plaus-overview .fa-bell').length === 0; }).removeClass("found");
        }

        me.visual.find('.blid.found').show();
        me.visual.find('.blid').not(".found").hide();
      
        return true;
       
    } catch (ex) { me.writeError('filter', ex); return false; }
};

DCOverview.prototype.setCurrentPlausList = function (data) {
    var me = this;
    try {

        
        me.visual.find(".plaus-overview").html("").removeClass("err");
        if (data === null) { alert(me.resources.err_loadData); return false; }
        if (data.rows !== null) {
          
            for (var i = 0; i < data.rows.length; i++) {
                if (data.rows[i].saptid === null) { data.rows[i].saptid = -2}
                switch (data.rows[i].saptid) {
                    case 0: //reminder
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span class='icon-color-error'><i class='fa-regular fa-bell '/>" + data.rows[i].signals + "</span>").addClass("err");

                        break;
                    case 122: //default plaus
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><u>" + data.rows[i].signals + "</u></span>");
                        break;
                    case 124: //shut down
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><i class='fa fa-power-off icon-color-error'/>" + data.rows[i].signals + "</span>");
                        break;
                    case 125: //disturbance
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><i class='fa-regular fa-exclamation-triangle icon-color-error'/>" + data.rows[i].signals + "</span>");
                        break;
                    case 126: //outlier
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><i class='fa-regular fa-check-circle  icon-color-error'/>" + data.rows[i].signals + "</span>");
                        break;
                    case 137: //constant control
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><i class='fa fa-heartbeat icon-color-ok'/>" + data.rows[i].signals + "</span>");
                        break;
                    case -1: //long term alarms
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span><i class='fa-regular fa-clock icon-color-warning'/>" + data.rows[i].signals + "</span>");
                        break;
                    case -2:// no assigned plausibility
                        me.visual.find('#blid' + data.rows[i].blid + " .plaus-overview").append("<span class='icon-color-error'><i class='fa fa-question icon-color-error'/>" + data.rows[i].signals + "</span>").addClass("err");
                       
                        break;
                }
            }
        }
        return false;
    } catch (ex) { me.writeError('.setCurrentPlausList', ex); return false; }
};

DCOverview.prototype.setCurrentAutoCheck = function (data) {
    var me = this;
    var sTmp;
    var sNew;
    try {


        me.visual.find(".auto-check-state").html("").removeClass("err new");
        if (data === null) { alert(me.resources.err_loadData); return false; }
        if (data.rows !== null) {

            for (var i = 0; i < data.rows.length; i++) {
                sTmp = "<span class='icon-color-error'><i class='fa-regular fa-bell '/>" + data.rows[i].current + "</span>";
                sTmp += "/<span class='icon-color-error'><i class='fa-regular fa-eye '/>" + data.rows[i].seen + "</span>";

                if(data.rows[i].current > data.rows[i].seen) {
                    sNew = "new";
                } else {
                    sNew = "";
                }
                me.visual.find('#blid' + data.rows[i].blid + " .auto-check-state").append(sTmp).addClass("err " + sNew);

            }
        }
        return false;
    } catch (ex) { me.writeError('.setCurrentAutoCheck', ex); return false; }
};
DCOverview.prototype.showAutoCheckPopup = function (blid) {
    var me = this;
   
    try {
        var popup = $("<div>").attr("id", "popupDialog");


        //get the windows height for our popup
        var h = $(window).height();
        if (h === 0) {
            h = $(document).height();
            if (h === 0) {
                h = document.body.scrollHeight;
            }
        }
        var w = parseInt($(window).width() * 0.9);
        h = parseInt(h * 0.9);

        popup.dialog({
            autoOpen: true,
            modal: true,
            width: w,
            height: h,
            resizable: false,
            dialogClass: "saveDialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+5%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });
        popup.html($("<div>").width(w-30).height(h-100));
        popup.find("div").AutoCheckOverview({ invokeType: "addVisualBase", parameter: { loggerid:blid} });
        //window.VisualCoreService.getVisualContentByName("VISUAL_PROJECT_SUMMARY",
        //    parseInt(Math.random() * 100000, 10), getCurrentTimestamp(), 750, 950, JSON.stringify({ 'loggerid': blid }), "", 2,
        //    function (result) {
        //        //redirect to logout if user is not authenticated
        //        if (visual.validLogin(result)) {
        //            popup.html(result);
        //            eval(popup);
        //        };
        //    }
        //);

        //alert(blid);

        return false;
    } catch (ex) { me.writeError('.showAutoCheckPopup', ex); return false; }
};

DCOverview.prototype.fetchSignals = function (obj) {
    ///send an getData to all signals 
    var me = this;
    try {
        obj.type = 0;
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(obj),
          function (result) {
              if (result === null) { alert(me.resources.err_saveData); return false; }
              return result;
          });
        return false;
    } catch (ex) { me.writeError('fetchSignals', ex); return false; }
};

DCOverview.prototype.setUnitStatus = function (values) {
    var me = this;
    var sTmp = "";
    try {


        if (values.broken > 0) {
            sTmp = "<span class='icon-color-error'>" + values.broken + "   <i class='fa fa-cog' ></i></span>";
        }
        if (values.alarms > 0) {
            if (sTmp.length > 0) { sTmp += " | "; }
            sTmp += "<span class='icon-color-error'>" + values.alarms + "   <i class='fa-regular fa-bell' ></i></span>";
        }
        if (values.tasks > 0) {
            if (sTmp.length > 0) { sTmp += " | "; }
            sTmp += values.tasks + "   <i class='fa fa-paper-plane' ></i>";
        }
        me.visual.find("#btn-devices .div-status").html(sTmp);
        // }
        return true;
    } catch (ex) { me.writeError('setUnitStatus', ex); return false; }
}

DCOverview.prototype.setLongTermStatus = function (values) {
    var me = this;
    var sTmp = "";
    try {


        if (values.alarms > 0) {
            sTmp += "<span class='icon-color-error'>" + values.alarms + "   <i class='fa fa-clock' ></i></span>";
        }

        me.visual.find("#btn-longterm .div-status").html(sTmp);
        // }
        return true;
    } catch (ex) { me.writeError('setUnitStatus', ex); return false; }
}

DCOverview.prototype.changeDataManageTypeID = function () {
    var me = this;
    try {

        if (me.error) {
            return false;
        }
        var blid = parseInt(me.visual.find('#ddlLoggers').val(), 10);
        var dmid = parseInt(me.visual.find('#ddlDataTypes').val(), 10);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 1, 'loggerid': blid, 'datamanagetypeid': dmid }),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                if (result === true) {
                    me.visual.find("#divInfoReloadPage").show();
                }
                return false;
            });
        return false;
    } catch (ex) {
        me.writeError('changeDataManageTypeID', ex);
        return false;
    }
};

DCOverview.prototype.setNewEditDay = function (obj) {
    var me = this;
    try {
        me.blid = obj.blid;
        me.day = obj.day;
        //me.updateTasks();
        return false;
    } catch (ex) { me.writeError('setNewEditDay', ex); return false; }
};

// TODO MKU: check if we need any other parameter which we send as start parameter to the archive
DCOverview.prototype.getSelectedParameter = function () {
    var me = this;
    var dates;
    var param;

    try {

        param = {
            'ShowInvalid': me.visual.find("#btn-invalid").hasClass("active"),
            'ShowInplausible': me.visual.find("#btn-inplausible").hasClass("active"),
            'ShowMissing': true,
        };

        param.ShowRules = me.visual.find("#chbIgnoreRules").prop("checked") === false;

        return param;
    } catch (ex) {
        me.writeError('getSelectedParameter', ex);
        return null;
    }
};


DCOverview.prototype.editDay = function (obj, type) {
  var me = this;
  var vcid = -1;
    try {        

        //first, we want to update the tasks to show the number of tasks in the edit forms
       
        switch (type) {
            case 0: vcid = me.vcid_datacenter_edit; break;
            case 1: vcid = me.vcid_datacenter_edit_single; break;
            case 2: vcid = me.vcid_datacenter_copy; break;
        }
       
        // new datacenter link to archive
        if (me.visual.find("#chbMultipleDC").prop("checked")) { // archive is opened

            var loggerName = me.visual.find('#blid' + obj.loggerid + ' .loggerName').html();

            var startParameter = me.getSelectedParameter();
            obj.StartParameter = startParameter;

            //startParameter.ShowErrorsOnly = obj.ShowErrorsOnly === true;

            $(document).trigger("openSelectedArchiveEvent", [obj, loggerName]);

        } else { // old datacenter
            me.blid = obj.loggerid;
            me.visual.find('#spanEditDayCaption').html(me.visual.find('#blid' + obj.loggerid + ' .loggerName').html());
            me.visual.find('#divEditDayChart').html(me.vcC.getLoadingIcon());
            me.visual.find('#divOverview').hide();
            me.visual.find('#divEditDay').show();
            me.vcVisual.addVisualBase('divEdit', vcid, 'DayChart', getCurrentTimestamp(), me.editFormHeight, me.editFormWidth - 20, JSON.stringify(obj), '', 1);
            return false;
        }

  } catch (ex) { me.writeError('editDay', ex); return false;} 
};  

DCOverview.prototype.getInfo = function (obj) {
    var me = this;
    try {

        obj.showSignalList = true;
        obj.EditMode = true;
        me.editDay(obj, 0);
        //showModalPopup("<div id='divSignalTree1'></div>", 1010, 770);
        //me.vcVisual.addVisualBaseByName('divSignal', 'VISUAL_DATACENTER_SIGNALTREE', 'Tree1', getCurrentTimestamp(), 750, 1000, JSON.stringify(obj), '', 1);
        return false;
    } catch (ex) { me.writeError('getInfo', ex); return false; }
};

function DCEdit() {
    this.dataSource = null;
    this.dttMinMax = null;
    this.menuFilter = "";
    this.editMode = { minplaus: 0, maxplaus: 0 };
    this.maxSignalsForChartLoading = 50;
    this.initialChartLoaded = false;
    this.initialState = true;
    this.editDate = "";
    this.bInitCal = false;
}
DCEdit.prototype = new DC();

DCEdit.prototype.init = function () {
    /// <summary>
    /// This function inits  <br/>
    /// </summary>
    var me = this;
    try {

       me.visual.find(".vc-box-filter").vcOptionBox({
           caption: me.resources.filter,
           items: [{ button: me.resources.allSignals, content: "", clickable: true, isList: false, funct: function () { me.filterSignalList(); } },
                   { button: me.resources.measurementsOnly, content: "", clickable: true, isList: false, funct: function () { me.filterSignalList(); } },
                   { button: me.resources.rulesOnly, content: "", clickable: true, isList: false, funct: function () { me.filterSignalList(); } }
           ]
       });
       
       var filter = $("<div>").attr("id", "div-filter");

       filter.append($("<div>").attr("id", "div-filter-all").data("type", -1).addClass("button-toggle margin").html(me.resources.all));
       filter.append($("<div>").attr("id", "div-filter-error").data("type", 0).addClass("button-toggle").html(me.resources.faulty));
       filter.append($("<div>").css("float", "left").css("margin", "0 3px 0 5px").html(" | "));
       filter.append($("<div>").attr("id", "div-filter-invalid").data("type", 1).addClass("button-toggle margin").html(me.erroricon + " " + me.resources.invalid));
       filter.append($("<div>").attr("id", "div-filter-inplausible").data("type", 2).addClass("button-toggle").html(me.inplausibleicon + " " +me.resources.inplausible));
       filter.append($("<div>").attr("id", "div-filter-missing").data("type", 3).addClass("button-toggle").html(me.missingicon + " " + me.resources.missing));
       me.visual.find(".vc-box-filter").append(filter);


       me.visual.find('.vc-box-filter #div-filter .button-toggle').off('click').on('click', function () {
           if ($(this).hasClass("button-toggle-active") === false) {
               me.visual.find('.vc-box-filter #div-filter .button-toggle').removeClass("button-toggle-active");
               $(this).addClass("button-toggle-active");
               me.filterSignalList();
           }
       });

        //deactive the 'show error only' button if we want to show all signals
        if (me.showErrorsOnly) {
            me.visual.find('.vc-box-filter #div-filter #div-filter-error').addClass("button-toggle-active");
        } else {
            me.visual.find('.vc-box-filter #div-filter #div-filter-all').addClass("button-toggle-active");
        }
      
        //init the main tag/tree menu
        me.initTreeMenu();


        //load all invalid data and add icons for invalid/inplausible/missing/measurementInactive
        me.loadInvalidSignals(true);

        //load all plausibilities for the current day
        me.setCurrentPlausibilities();

        //hide all signals which have not been marked as selected on start (server-side)
        me.visual.find(".signallist").not(".selected").hide();



        me.visual.find(".vc-cal-edit").vcDateBox( {
            mode: "Single", interval: 1, langID: me.UserLangIDForCulture, defaultDate: me.day,
            callback: function (obj) {
                if (me.bInitCal === false) { me.bInitCal = true;return true }
               
                //set the edit date
                  me.day = obj.singleDate;
                 
                  me.visual.find('#divLegend .legend-edit').html(me.resources.editOn).removeClass('legend-edit-on');
                  if (me.editMode.dirty) {
                      me.saveDialog();
                  } else {
                      me.resetLegend(true);
                  }
               
                  if (me.visual.find(".subform.button-toggle-active").length === 0) {
                      _VCMQ.produce(me.visual, me.vcgid, 'SET_EDIT_DAY', { 'blid': me.blid, 'day':me.day });
                  } else {
                      //hehe, let's make a trick
                      //mark the currently open subform as not open and then toggle it again ;-)
                      var subform = me.visual.find(".subform.button-toggle-active");
                      subform.removeClass("button-toggle-active");
                      me.toggleSubForm(subform);
                  }
                 
                  if (me.loadInvalidSignals()) {
                      me.setCurrentPlausibilities();
                  }
                me.bInitCal = true;
                return true;
            }
          }
      );
        var sTasks = "<select id='ddlSendTask' class='ddl' ><option value='recalcData'>recalcData</option><option value='importData'>importData</option><option value='importRawData'>importSrvData</option><option value='delData'>delData</option><option value='delSrvData'>delSrvData</option></select>";
        me.visual.find(".vc-tasks-send").vcOptionBox({caption:me.resources.tasks,
            items: [
                {
                    button:sTasks + "<div id='btnDoSendTasks' class='button-toggle'>" + me.resources.sendTasks + "</div>", content:$("<div>").attr("id","vc-cal-tasks"), isList: false
                }
            ]
        });

        me.visual.find("#vc-cal-tasks").vcDate({ mode: "Range", interval: 1, langID: me.UserLangIDForCulture,defaultRange:{from: me.day, to:me.day}});

        me.visual.find(".chart,#divMenuUpdate,#divTooltip,#divData,#divCopy").width(me.width - parseInt(me.visual.find("#divLegend").width(), 10) - 27);
      

        //fills the 96 input fields for data editing
        me.generateDataList();

        //fix widths 
        me.visual.find(".signal-frame").width(me.width - parseInt(me.visual.find(".vc-tree-menu").width(), 10) - 20);

        me.visual.find("#divSaveInfo").css("margin-left", parseInt((me.visual.find("#divMenuUpdate").width() - me.visual.find("#divSaveInfo").width()) / 2, 10));
        me.visual.find(".chartSource").width(parseInt(me.visual.find("#divCopy").width(), 10) );
 
        me.visual.find('#chbAllSignals').off("click").on('click', function () { me.selectAllSelectionSignals(true); });
    
        // reload chart
        me.visual.find('#btnReload').off('click').on('click', function () { me.loadInvalidSignals(); });
        //highlight series
        me.visual.find('.legend').unbind('hover').hover(function () { me.hoverLegend(this, true); }, function () { me.hoverLegend(this, false); });
        //show/hide legend
        me.visual.find('.legend').off('click').on('click', function (e) { me.toggleLegend(e, this); });
        //start/stop edit mode
        me.visual.find('.legend-edit').off('click').on('click', function () { me.toggleEditMode(this); });

        me.visual.find('#div-ds-edit2').off('click').on('click', function () { me.showEdit2Popup()});


        //click handlers in chart/signal selection
        //****************************************
        //init the filter 
        me.visual.find("#div-edit-filter").vcFilter({ callback: function () { me.filterSignalList() } });



        //switch between signal list and chart
        me.visual.find('#btnSelection').off('click').on('click', function () { me.toggleSelection();
            me.hideEditDetailForm();
        });
        //select/unselect one single signal
        me.visual.find('li.signallist').off('click').on('click', function () { me.toggleSelectionSignal(this); });

        //click handler for the signal info popup
        me.visual.find('li.signallist').off('click', ".btnSignalInfo").on('click', ".btnSignalInfo", function (e) {
            var bsaid = parseInt($(this).attr("data-id"), 10);
            me.vcVisual.showSignalAnalogSummaryDialog(bsaid);
            e.stopPropagation();
        });


        me.tickets.forEach(function (e) {
            me.visual.find("#signallist #bsaid" + e + " .btnSignalTicket").css("opacity", 1);
        });
        //click handler for the ticket info popup
        me.visual.find('li.signallist').off('click', ".btnSignalTicket").on('click', ".btnSignalTicket", function (e) {
            var bsaid = parseInt($(this).attr("data-id"), 10);
            me.vcVisual.showSignalTicketDialog(me.blid,bsaid);
            e.stopPropagation();
        });

        //click handler for the dims-edit popup
        me.visual.find('li.signallist').off('click',  ".dims").on('click',".dims", function (e) {
            var obj = {};
            obj.bsaid = parseInt($(this).attr("id").replace("unit", ""), 10);
            obj.type = 0;
            me.showValueEditorPopup(obj);
            e.stopPropagation();
        });
        //click handler for the mkorr-edit popup
        me.visual.find('li.signallist').off('click', ".mkorr").on('click',".mkorr", function (e) {
            var obj = {};
            obj.bsaid = parseInt($(this).attr("id").replace("mkorr", ""), 10);
            obj.type = 1;
            me.showValueEditorPopup(obj);
            e.stopPropagation();
        });
        //click handler for the skorr-edit popup
        me.visual.find('li.signallist').off('click', ".skorr").on('click', ".skorr", function (e) {
            var obj = {};
            obj.bsaid = parseInt($(this).attr("id").replace("skorr", ""), 10);
            obj.type = 2;
            me.showValueEditorPopup(obj);
            e.stopPropagation();
        });

        //do nothing!?
        me.visual.find('li.signallist').off('click', ".plaus").on('click', ".plaus", function (e) { e.stopPropagation(); });

        //select one single signal and show it in the chart
        me.visual.find('li.signallist').off('click', ".btnEditSingle").on('click', ".btnEditSingle", function (e) { me.selectSingleSignal(parseInt($(this).attr("data-id"), 10), me.day); e.stopPropagation(); });
      
        //show /hide the plausibility form
        me.visual.find('li.signallist').off('click', ".btnEditPlaus").on('click', ".btnEditPlaus", function (e) { me.showEditDetailForm(this); e.stopPropagation(); });

        //show /hide the plausibility form
        me.visual.find('li.signallist').off('click', ".btnShowRules").on('click', ".btnShowRules", function (e) { me.showEditDetailForm(this); e.stopPropagation(); });
        //show /hide the plausibility form
        me.visual.find('li.signallist').off('click', ".btnEditDetailClose").on('click', ".btnEditDetailClose", function (e) { me.hideEditDetailForm(); e.stopPropagation(); });
       
        //edit and save handlers
        me.visual.find(".valbox input").off("change").on("change", function () { me.editPoint($(this)); });
        me.visual.find('.valbox input').off('keyup').on('keyup', function () { me.validatePoint($(this)); });

        me.visual.find('#btnSave').button().off('click').on('click', function () { me.save(); });
        me.visual.find('#btnLog').button().off('click').on('click', function () { me.toggleLog(); });

        //copy day click handlers
        me.initCalendar(me.visual.find('#txtDateSource'));
        me.visual.find('#txtDateSource,#ddlSignalSource,#ddlArchiveSource').on("change", function () { me.showCopyChart(); });
        me.visual.find('#btnCopy').button().off('click').on('click', function () { me.copyData(); });

        me.visual.find('#iconDatePrevSource').off('click').on('click', function () {me.navigateDate(me.visual.find('#txtDateSource'), -1, false);me.showCopyChart();});
        me.visual.find('#iconDateNextSource').off('click').on('click', function () {me.navigateDate(me.visual.find('#txtDateSource'), 1, false);me.showCopyChart();});

        me.visual.find('#chkShowCopy').off('click').on('click', function() {
            if ($(this).is(':checked')) {
                me.visual.find('#divCopyForm').show();
                me.showCopyChart();
            } else {
                me.visual.find('#divCopyForm').hide();
            }
        });

        me.visual.find('#btnDoSendTasks').off('click').on('click', function () { me.sendTasks(); });

        //init the click handler for the various subform icons
        me.visual.find("#btnShowMultiPlaus,#btnShowAlarm,#btnShowInterventions,#btnSingleEditDay,#btnRangeEditDay,#btnArchiveStatus, #btnArchiveExport").off('click').on('click', function () { me.toggleSubForm($(this)); });

      


        return false;
    } catch (ex) { me.writeError('init', ex);return false; }
};


DCEdit.prototype.showEdit2Popup = function () {
    /// <summary>
    /// This function ...
    /// </summary>
    var me = this;
   
    try {

        if (me.error) { return false }

        me.vcVisual.showDsEdit2Dialog({ LoggerId: me.blid, bsaid: me.editMode.guid, day: me.day });

        //var p = 0.98;
        ////get the windows height for our popup
        //h = $(window).height();
        //if (h === 0) {
        //    h = $(document).height();
        //    if (h === 0) {
        //        h = document.body.scrollHeight;
        //    }
        //}
        //w = parseInt($(window).width() * p);
        //h = parseInt(h * p);


        //showModalPopup("<div id='divDSEdit2' style='height:" + (h-40) + "px;width:" + (w-20) + "px'></div>", w, h);
        //$("#divDSEdit2").DsEdit2({ invokeType: "addVisualBase", parameter: { LoggerId: me.blid, bsaid: me.editMode.guid, day: me.day } });


        return true;
    } catch (ex) { me.writeError('showEdit2Popup', ex); return false; }
};















DCEdit.prototype.generateDataList = function () {
    /// <summary>
    /// This function generates 96 input fields for the data editing in the edit mode <br/>
    /// </summary>
    var me = this;
    var i;
    var counter = 0;
    try {

        if (me.error) {return false }
        
        var widthData = parseInt(me.visual.find("#divData").width(), 10);
        var widthBox = parseInt(me.visual.find(".valbox").width(), 10);
        var cols = widthData / widthBox;
        var rows;
      
        if ((96 % cols) > 0) {
            rows = parseInt(96 / cols, 10) + 1;
        } else {
            rows = parseInt(96 / cols, 10);
        }
        var widths = parseInt(110 / cols, 10);

        var boxlist = me.visual.find("#divDataList").html().split("|");
        var sTmp = "<div style='float:left;width:" + widths + "%'>";

        for (i = 0; i < 96; i++) {
            if (counter < rows) {
                sTmp += boxlist[i].replace("|", "");
                counter++;
            } else {
                sTmp += "</div>";
                if (i < 96) {
                    sTmp += "<div style='float:left;width:" + widths + "%'>";
                    sTmp += boxlist[i].replace("|", "");
                    counter = 1;
                }
            }
        }
        sTmp += "</div>";
        me.visual.find("#divDataList").html(sTmp);

        return true;
    } catch (ex) { me.writeError('generateDataList', ex); return false; }
};

DCEdit.prototype.filterSignalList = function () {
    /// <summary>
    /// This function does the list filtering. <br/>
    /// It receives an optional menu filter string from the vc-tree-menu or a list of filter tags from the vc-filter item.<br/>
    /// It iterates all list entries and increases a counter for each found filter item and signal. Then, it hides all entries where the counter is lower than the number of filter items. <br/>
    /// </summary>
    var me = this;
  
    var item;
    var tags;
    var tagsSingle;
    var i;
    var text;
    try {
        if (me.error) {
            return false;
        }

        //hide and reset everything
        me.visual.find('.signallist').data('counter', 0).removeClass('icon-color-error tag-found menu-filter-found selected').hide();

        //first we filter all signals with the tag we got from the vc-tree-menu
        if (me.menuFilter.length > 0) {

            if (me.menuFilter !== 'has_ticket') {
                me.visual.find('.signallist').filter(function() {
                    tags = [];
                    item = $(this);
                    tagsSingle = $(this).find(".tags").html().split(";;;");
                    for (i = 0; i <= tagsSingle.length - 1; i++) {
                        tags.push.apply(tags, tagsSingle[i].split(" / "));
                    }

                    for (i = 0; i <= tags.length - 1; i++) {
                        text = $("<div/>").html(tags[i]).text();
                        if (text.trim() === me.menuFilter) {
                            item.addClass("menu-filter-found");
                            return true;
                        }
                    }
                    return false;

                    //  return $(this).find(".tags:contains('" + me.menuFilter + "')").length > 0
                }).addClass("menu-filter-found");

            } else {
                if (me.menuFilter === 'has_ticket') {
                    
                    //we have to find every signal which have no tags assigned (except the vc-tags-item-system which every item gets automatically)
                    me.visual.find('.signallist').filter(function () {
                        
                        return $(this).find(".fa-ticket").css("opacity") === "1";
                    }).addClass("menu-filter-found");
                }
            }


        } else {
            me.visual.find(".signallist").addClass("menu-filter-found");
        }

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter("#div-edit-filter", ".signallist", "tag-found");


        var type = parseInt(me.visual.find(".vc-box-filter").vcOptionBox("getIndex"));
        var state = me.visual.find(".vc-box-filter #div-filter .button-toggle-active").data("type");
       
        switch (type) {
            //case 0:
            case 1:
                me.visual.find(".signallist.tag-found.menu-filter-found.rule").removeClass("menu-filter-found selected");
                break;
            case 2:
                me.visual.find(".signallist.tag-found.menu-filter-found").not('.rule').removeClass("menu-filter-found selected");
                break;
            default:
        }

        switch (state) {
            case 0:
                me.visual.find(".signallist").not(".err").removeClass("menu-filter-found selected");
                break;
            case 1:
                me.visual.find(".signallist").filter(function () { return $(this).find('.fa-times-circle').length === 0; }).removeClass("menu-filter-found selected");
                break;
            case 2:
                me.visual.find(".signallist").filter(function () { return $(this).find('.fa-exclamation-triangle').length === 0; }).removeClass("menu-filter-found selected");
                break;

            case 3:
                me.visual.find(".signallist").filter(function () { return $(this).find('.fa-question-circle').length === 0; }).removeClass("menu-filter-found selected");
                break;
            default:
        }


        //show only valid entries
        me.visual.find(".signallist.tag-found.menu-filter-found").addClass("selected").show();



        if (me.visual.find('#chbAllActiveSignals').is(':checked')) {
            me.selectAllSelectionSignals(false);
        }

        return true;
    } catch (ex) { me.writeError('filterSignalList', ex); return false; }
};

DCEdit.prototype.initTreeMenu = function () {
    /// <summary>
    /// This function inits the vc-tree-menu object and sets the callback handlers <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        
        me.visual.find('.vc-tree-menu').show().html(me.vcC.getLoadingIcon());

     

        //init list entry click handler
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 5,'loggerid':me.blid, 'day': me.day }),
          function (result) {


              if (result == null) { me.visual.find('.vc-tree-menu').html(me.resources.err_loadData); return false; }
              if (result.rows === null) { me.visual.find('.vc-tree-menu').html(me.resources.err_loadData).show(); return false; }
              if (result.rows.length === 0) {
                  me.visual.find('.vc-tree-menu').html(me.resources.noEntriesExist).show();
                  return false;
              }
              me.visual.find('.vc-tree-menu').vcTreeMenu({
                  "h": parseInt(me.visual.find('.vc-tree-menu').height(), 10),
                  "showAllAtStart": me.showErrorsOnly,
                  "data": result,
                  "showNotAssigned": false,
                  "clearFilter":true,
                  "showErrors": true,
                  "callback": function (e) {
                      switch (e.type) {
                          case "init":
                              me.menuFilter = e.value;
                              me.hideEditDetailForm();
                              me.filterSignalList();
                              break;
                          case "update":
                              me.menuFilter = e.value;
                              me.hideEditDetailForm();
                              me.filterSignalList();
                              break;
                          case "error":
                              me.writeError('initMenu.vcTreeMenu', e.value);
                              break;
                          default:
                      }
                  }
              });
              return true;
          });

        return true;
    } catch (ex) { me.writeError('initTreeMenu', ex); return false; }
};

DCEdit.prototype.doEvent = function(event) {
    var me = this;
    try {
        if (event.values !== null) {
            if (event.values.sender === me.vcgid) {
                switch (event.msg) {
                    case 'RAMP_SERIES': me.setSeriesIndex(event.values.series);break;
                case 'RAMP_DATA':me.fillData(event.values);break;
                case 'RAMP_STATE':me.setState(event.values);break;
                default: break;
                }
            }
            if (event.values.sender === me.chartVcgid) {
                switch (event.msg) {
                case 'RAMP_POINT_DROP': me.setDroppedPoint(event.values); break;
                case 'RAMP_TOOLTIP':me.showTooltip(event.values); break;
                default: break;
                }
            }
        }

        switch (event.msg) {
          case 'DC_ERROR':
              me.showMessage(me.resources.err_code, true);break;
            case 'SELECT_SINGLE_SIGNAL':
                me.selectSingleSignal(event.values.id, event.values.day);
                break;
            case 'OPEN_EDIT_CHART':
                me.editMode.unplaus = event.values.minplaus;
                me.editMode.obplaus = event.values.maxplaus;

                me.reload(me.currentSeriesIndex);
                break;
          default:break;
        }
        return false;
    } catch (ex) { me.writeError('doEvent', ex);return false;}
};

DCEdit.prototype.reload = function(seriesIndex) {
    var me = this;
    try {




        me.hideOthers();

        if (me.editMode.dirty) {
            me.saveDialog();
            return false;
        } else {
            me.editMode.seriesIndex = seriesIndex;
            if (seriesIndex === -1) {
                me.editMode.active = false;
                me.editMode.guid = -1;
               
            }
        }
        if (me.editMode.active === false) {
            me.visual.find('.legend-edit').not(":contains('DONE')").html(me.resources.editOn)
                .removeClass('legend-edit-on');
            me.visual.find('.legend-edit').removeClass('legend-edit-on');
            me.visual.find("#divMenuUpdateSave,#divLog,#divCopy").hide();
            me.visual.find("#divInfo").show();

        } 

        if (me.reset === true) {
            me.reset = false;
            me.showMessage('');
        }
        me.visual.find('#divLegend').addClass('legend-loading');
        me.visual.find("#divSelection").hide();
        me.visual.find("#divSignallist #divEditPlaus").html("");
        me.visual.find("#divData").hide();

  
        //optionally we open the signal list directly when opening the form
        if (me.showSignalList) {
            me.toggleSelection();
            me.hideEditDetailForm();
            me.showSignalList = false;
        } else {
            me.initChart();
        }

      

        return false;
    } catch (ex) {me.writeError('reload', ex);return false;}
};

DCEdit.prototype.navigateDate = function (obj, interval, isMainDate) {
    var me = this;
    var subform;
    try {
        var dt = $.datepicker.parseDate('dd.mm.yy', obj.val());
        dt.setDate(dt.getDate() + interval);
        obj.datepicker('setDate', dt);
        if (isMainDate) {
            _VCMQ.produce(me.visual, me.vcgid, 'SET_EDIT_DAY', { 'blid': me.blid, 'day':$.datepicker.formatDate('dd.mm.yy', dt) });   
            me.visual.find('#divLegend .legend-edit').html(me.resources.editOn).removeClass('legend-edit-on');
            if (me.editMode.dirty) {
                me.saveDialog();
            } else {
                if (me.visual.find(".subform.button-toggle-active").length === 0) {
                    me.loadInvalidSignals();
                } else {
                    //hehe, let's make a trick
                    //mark the currently open subform as not open and then toggle it again ;-)
                    subform = me.visual.find(".subform.button-toggle-active");
                    subform.removeClass("button-toggle-active");
                    me.toggleSubForm(subform);
                }


            }
        }
    } catch (ex) {me.writeError('navigateDate', ex);}
};

DCEdit.prototype.toggleSelection = function() {
    var me = this;
    try {
        if (me.error) { return false;}
        if (me.visual.find('#divSelection').is(':visible')) {
            me.visual.find('#divSelection').hide();
            me.visual.find("#divSignallist #divEditPlaus").html("");
            me.resetLegend();
        } else {
            me.visual.find("#divSingleDataEditPlaus").html("").hide();
            me.visual.find('#divCopyForm').hide();
            me.visual.find("#chkShowCopy").prop("checked", false);
            me.hideOthers();
            me.markDoubleSettings();
            me.setCurrentPlausibilities();
            me.visual.find('#divSelection').show();
        }
        return false;
    } catch (ex) {me.writeError('toggleSelection', ex);return false;}
};

// ReSharper disable once UnusedParameter
DCEdit.prototype.selectSingleSignal = function (id, date) {
    var me = this;
    try {
        if (me.error) {return false;}
       // me.visual.find('#txtDateStart').val(date);



        me.visual.find('#chkInvalidSignals').prop('checked', false);
        
        me.visual.find('li.signallist').removeClass('selected');
        me.visual.find('#bsaid' + id).addClass("selected");
        
        me.visual.find('#divSelection').hide();
        me.visual.find("#divSignallist #divEditPlaus").html("");
        
        me.loadInvalidSignals();
        return true;
    } catch (ex) { me.writeError('selectSingleSignal', ex);return false;}
};

DCEdit.prototype.toggleSelectionSignal = function(obj) {
    var me = this;
    try {
        if ($(obj).hasClass('selected')) {
            $(obj).removeClass('selected');
        } else {
            $(obj).addClass('selected');
        }
        return false;
    } catch (ex) {me.writeError('toggleSelectionSignal', ex); return false;}
};

DCEdit.prototype.selectAllSelectionSignals = function( bAll) {
    var me = this;
    
    try {
        if (bAll) {
            if (me.visual.find('#chbAllSignals').prop('checked')) {
                me.visual.find("li.signallist:visible").addClass('selected');
                me.visual.find('#chbAllActiveSignals').prop('checked', false);
            } else {
                me.visual.find("li.signallist:visible").removeClass('selected');
            }
        } else {
            if (me.visual.find('#chbAllActiveSignals').prop('checked')) {
                me.visual.find("li.signallist:visible").not(".selected").addClass('selected');
                me.visual.find("li.signallist.rule:visible").removeClass('selected');
                me.visual.find("li.signallist .fa-plug,li.signallist .fa-question-circle").parents("li.signallist").removeClass('selected');
                me.visual.find('#chbAllSignals').prop('checked', false);
            } else {
                me.visual.find("li.signallist:visible").removeClass('selected');
            }
        }
        return false;
    } catch (ex) { me.writeError('selectAllSelectionSignals', ex);return false;}
};

DCEdit.prototype.toggleLog = function() {
    var me = this;
    try {
        if (me.visual.find('#divLog').is(':visible')) {
            me.visual.find('#divLog').hide();
        } else {
            me.showLog();
        }
        return false;
    } catch (ex) { me.writeError('toggleLog', ex); return false;}
};

DCEdit.prototype.toggleLegend = function(e, obj) {
    var me = this;
    try {
        if (me.error || me.reset) { return false; }
        if (e.target.className.indexOf('legend-edit') > -1) { return false;}
        if ($(obj).parents('#divLegend').hasClass('legend-loading')) {return false;}
        var seriesIndex = $(obj).find('.index').html();
        if ($(obj).hasClass('legend-hidden')) {
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_TOGGLE_SERIES', { 'target': me.chartVcgid, 'index': seriesIndex, 'show': true });
            $(obj).removeClass('legend-hidden');
            $(obj).find('.legend-edit').show();

        } else {
            if ($(obj).find('.legend-edit-on').length > 0) {
                // init chart in basic mode to reset the state
                $(obj).addClass('legend-hidden');
                me.reload(-1);
            } else {
                _VCMQ.produce(me.visual, me.vcgid, 'RAMP_TOGGLE_SERIES', { 'target': me.chartVcgid, 'index': seriesIndex, 'show': false });
                $(obj).addClass('legend-hidden');
            }
            $(obj).find('.legend-edit').hide().html(me.resources.editOn).removeClass('legend-edit-on');
        }
        return false;
    } catch (ex) { me.writeError('toggleLegend', ex);return false;}
};

DCEdit.prototype.toggleEditMode = function(obj) {
    var me = this;
    try {
        if (me.error || me.reset) { return false; }


        me.visual.find("#div-plaus-details").html("");

        if ($(obj).parents('#divLegend').hasClass('legend-loading')) { return false; }
        //clear all possibly open plausibility forms
        me.visual.find(".dc-plausibility").html("");
        
        me.visual.find("#divSingleDataEditPlaus").html("").hide();
        me.currentSeriesIndex =  parseInt($(obj).siblings('.index').html(), 10);

        if ($(obj).hasClass('legend-edit-on')) {
            me.saveDialog($(obj), true);
        } else {
            if (me.editMode.seriesIndex !== me.currentSeriesIndex && me.editMode.seriesIndex > -1) {
                me.saveDialog();
            } else {
               
                me.editMode.active = true;
                var guid = $(obj).parents('.legend').attr('id');
                guid = parseInt(guid.replace('bsaid', ''), 10);
                me.editMode.guid = guid;
               


                //me.showEdit2Popup();
                //return true;

                $(obj).html(me.resources.editOff).addClass('legend-edit-on');

                me.visual.find("#divSingleDataEditPlaus").show();

                var param = { "bsaid": guid, "loggerid": me.blid, "day": me.day, "ShowCurrentPlaus": true, "showToggleButton": true };

                var container = me.getRandomIDContainerObj("divSingleDataEditP", true);
                container.obj.css("max-height",800);
                me.visual.find("#divSingleDataEditPlaus").html(container.obj);


                //console.info($(obj).data("hrbased"));

                //if ($(obj).data("hrbased") === false) {
                    me.vcVisual.addVisualBaseByName('divSingleDataEditP',
                        'VISUAL_DATACENTER_PLAUS',
                        container.random,
                        me.day,
                        800,
                        parseInt(me.visual.find("#divData").width(), 10),
                        JSON.stringify(param),
                        '',
                        1);
                //} else {
                //    alert();
                //    container.obj.width(parseInt(me.visual.find("#divData").width(), 10));
                //    container.obj.height(800);
                //    $(container.obj).HRManualEdit({ invokeType: "addVisualBase", parameter: { type: 1, bsaid:guid } });
                //}

                // me.reload(me.currentSeriesIndex);

                me.showEdit2Popup();
            }
        }
        return false;
    } catch (ex) { me.writeError('toggleEditMode', ex); return false;}
};

DCEdit.prototype.hoverLegend = function(obj, on) {
    var me = this;
    try {
        if ($(obj).parents('#divLegend').hasClass('legend-loading')) {
            return false;
        }
        var seriesIndex = $(obj).find('.index').html();
        if (seriesIndex === '') { return false; }

        _VCMQ.produce(me.visual, me.vcgid, 'RAMP_HOVER_SERIES', { 'target': me.chartVcgid, 'index': seriesIndex, 'show': on });
        return false;
    } catch (ex) {me.writeError('hoverLegend', ex);return false;}
};

DCEdit.prototype.resetLegend = function(bHideMessage) {
    var me = this;
    try {
        me.reset = true;
        me.visual.find('#div' + me.vcgid + me.chartVcgid).html('');
        if (bHideMessage===false) {me.showMessage(me.resources.reloadChart, false);}
        me.refreshLegend();
        return false;
    } catch (ex) {me.writeError('resetLegend', ex);return false;
    }
};
//end click and event handlers
//------------------------------

//refreshes legend after updating invalid signals and selecting charts
DCEdit.prototype.refreshLegend = function() {
    var me = this;
    var signalList;
   // var iSignalCounter = 0;
    try {
        if (me.error) {return false;}
        me.visual.find('.legend').hide();
        signalList = me.visual.find("li.signallist.selected");

         signalList.each(function() {
             me.visual.find("#" + $(this).attr("id") + ".legend").show();
             //if (me.initialState) {
                 //iSignalCounter++;
                 //if (iSignalCounter >= me.maxSignalsForChartLoading) { return false }
             //}
         });
         me.initialState = false;
        return false;
    } catch (ex) { me.writeError('refreshLegend', ex);return false;}
};

DCEdit.prototype.loadInvalidSignals = function(bFilter) {
    var me = this;
    var stateIcons = "";
    var hasError = false;
    try {
        if (me.error) {
            return false;
        }
      
        //clear all possibly open plausibility forms
        me.visual.find(".dc-plausibility").html("");

        me.visual.find('li .stateIcons,.legend .stateicon').html('');
        me.visual.find('li.signallist').removeClass('err');
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 0, 'loggerid': me.blid, 'day': me.day}),
            function(data) {
                if (data === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                me.invalidsignals = data;

                if (me.invalidsignals.rows !== null) {
                    for (var i = 0; i < me.invalidsignals.rows.length; i++) {
                        stateIcons = "";
                        hasError = false;
                        if (me.invalidsignals.rows[i].archiveid === null) {
                            if (me.visual.find('#bsaid' + me.invalidsignals.rows[i].id + '').hasClass("rule") === false) {
                               
                                if (me.invalidsignals.rows[i].measure) {
                                    stateIcons += me.missingicon + " <span style='display:none'>" + me.missing_tooltip + "</span>";
                                    hasError = true;
                                } else {
                                    stateIcons += me.measurementInactiveIcon + " <span style='display:none'>" + me.measurementInactive_tooltip + "</span>";
                                }
                            } else {
                              
                                if (me.invalidsignals.rows[i].rid !== null) {
                                    stateIcons += me.missingicon + " <span style='display:none'>" + me.missing_tooltip + "</span>";
                                    hasError = true;
                                } else {
                                    stateIcons += me.measurementInactiveIcon + " <span style='display:none'>" + me.measurementInactive_tooltip + "</span>";
                                }
                              
                            }
                             
                        } else {
                            if (me.invalidsignals.rows[i].valid === false) { hasError = true; stateIcons += me.erroricon + " <span style='display:none'>" + me.error_tooltip + "</span>"; }
                            if (me.invalidsignals.rows[i].plausible === false) { hasError = true; stateIcons += me.inplausibleicon + " <span style='display:none'>" + me.inplausible_tooltip + "</span>"; }
                            if (me.invalidsignals.rows[i].measure === false) { stateIcons += me.measurementInactiveIcon + " <span style='display:none'>" + me.measurementInactive_tooltip + "</span>"; }
                        }

                        //sTmp += "<i data-type='TICKET' class='vc-list-icon ticket popup fa fa-ticket-alt color-font-secondary'  title='" + me.resources.ticket + "'></i>";
                    
                        me.visual.find('#bsaid' + me.invalidsignals.rows[i].id + ' .stateIcons,#divLegend #state' + me.invalidsignals.rows[i].id + '').html(stateIcons);
                       if (hasError) { me.visual.find('#bsaid' + me.invalidsignals.rows[i].id + '.signallist').addClass('err');}
                    }
                }

                var vcgid = "";
                var counter = 0;
                me.visual.find("li.chartlist").each(function() {
                    vcgid = $(this).attr("id");
                    counter = me.visual.find("li.signallist." + vcgid + ".err").length;
                    if (counter > 0) {
                        $(this).find('span').show().html(counter);
                    } else {
                        $(this).find('span').hide().html("");
                    }
                });

               if (bFilter) {me.filterSignalList();}

                me.refreshLegend();
                // me.setCurrentPlausibilities();
                me.reload(-1);

              
                var errorTags = [];
                $(".signallist.err .tags").each(function () { errorTags.push($(this).html()) });

             
                ////get filter tags from the filter object
                me.visual.find(".vc-tree-menu").vcTreeMenu("setErrors", errorTags);


                $(".DC.DCEdit").height($("#divEditDayChart").height()-25).css("overflow-y", "auto");
                me.visual.find("#divLegend").height($(".DC.DCEdit").height() - me.visual.find("#divMenu").height()-20);
                return true;
            });
        return true;
    } catch (ex) { me.writeError('loadInvalidSignals', ex);return false;}
};

DCEdit.prototype.initChart = function() {
    var me = this;
    var hiddenSeries = [];
    var signalParam = { 'series': [] };
    var id;
    var bEditMode = false;
    try {
        
        if (me.error) {return false;}
        //me.day = me.visual.find('#txtDateStart').val();
       // me.day = me.editDay;
        var bEdit = false;


        if (me.visual.find('.legend-edit-on:visible').length > 0) {
            bEditMode = true;
        }

        me.visual.find('.legend:visible').each(function() {
            id = $(this).attr('id');
            id = parseInt(id.replace('bsaid', ''), 10);

            if (me.editMode.guid === id) {
                bEdit = true;
             
                signalParam.series.push({ 'bsaid': [id], 'rule': '[bsaid=' + id + ']', 'ruleType': 1, 'guid': id, 'edit': bEdit });
                if ($(this).hasClass('legend-hidden')) { hiddenSeries.push(id); }
            } else {
              
               if (bEditMode === false) {
                   signalParam.series.push({ 'bsaid': [id], 'rule': '[bsaid=' + id + ']', 'ruleType': 1, 'guid': id, 'edit': false });
                   if ($(this).hasClass('legend-hidden')) { hiddenSeries.push(id); }
               }
            }

        });


        var param = {'loggerID': me.blid,'ExternalTooltip': true,'fixTooltip': true,'ShowInvalidValues': true,'ShowPlotLines': true,'datatype': 1,'startDate': me.day,
            'endDate': me.day, 'ListHiddenSeries': hiddenSeries, 'HideSeries': true, 'ShowEmptyChart': true, 'DecimalPlace': 3, 'HideNotAllowedIntervals': false, 'LimitMinToNull': false,
            'showMinMaxPlots': false, "ShowIntervention":true, "ShowUnsmoothedValues":true
        };

       

        if (signalParam.series.length === 0) {
            me.visual.find('#div' + me.vcgid + me.chartVcgid).html("");
            me.showMessage(me.resources.noSignalsSelected, false);
            return false;
        } else {
            me.showMessage("");
        }
        
        if (signalParam.series.length > me.maxSignalsForChartLoading && me.initialChartLoaded === false) {
            me.initialChartLoaded = true;
            me.visual.find('#divLegend').removeClass("legend-loading");
            me.visual.find('#div' +me.vcgid +me.chartVcgid).html(me.resources.tooManySignalsInChart + " <div id='btn-manual-refresh' >" +me.resources.loadChartNow + "</div>");
            me.visual.find("#btn-manual-refresh").off("click").on("click", function() { me.initChart(true);}).button();
            return false;
       }
        me.initialState = false;
        me.initialChartLoaded = true;
      
        if (bEditMode && bEdit) { param.EditMode = true; }

        me.visual.find('#div' + me.vcgid + me.chartVcgid).html(me.vcC.getLoadingIcon());
       
        me.vcVisual.addRampBaseByName('div' + me.vcgid, 'VISUAL_DATACENTER_SINGLE_EDIT', me.chartVcgid, getCurrentTimestamp(), me.visual.find('.chart').height(), me.visual.find('.chart').width(), JSON.stringify(param), JSON.stringify(signalParam), 1, function () {
            //get all series indexes and series color
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_GET_SERIES', { 'sender': me.vcgid, 'target': me.chartVcgid });
        });
        return false;
    } catch (ex) {me.writeError('initChart', ex);return false;}
};

DCEdit.prototype.initCopyChart = function () {
    var me = this;
    try {
        me.visual.find('#ddlSignalSource').val(me.editMode.guid);
        me.showCopyChart();
        return true;
    } catch (ex) {me.writeError('initCopyChart', ex);return false;}
};

DCEdit.prototype.showCopyChart = function () {
    var id;
    var date;
    var me = this;
    var signalParam = { 'series': [] };
    var hiddenSeries = [];
    try {
        if (me.error) { return false;}
        if (me.visual.find('#chkShowCopy').is(':checked') === false) { return false;}

        id = parseInt(me.visual.find('#ddlSignalSource').val(), 10);
        date = me.visual.find('#txtDateSource').val(); 
        me.visual.find('#divSource' + me.chartVcgid).html(me.vcC.getLoadingIcon());

        signalParam.series.push({ 'bsaid': [id], 'rule': '[bsaid=' + id + ']', 'ruleType': 1, 'guid': id, 'edit': false });

        var param = {'loggerID': me.blid,'ShowInvalidValues': true,'ShowPlotLines': true,'datatype': 1,'startDate':date,'endDate': date,
            'ShowIntervention': false, 'ListHiddenSeries': hiddenSeries, 'HideSeries': true, 'ShowEmptyChart': true, 'DecimalPlace': 3, 'HideNotAllowedIntervals':false,
            'UseRawDataForSingleValues': me.visual.find('#ddlArchiveSource').val(),'GetSingleValuesAsConsumption':false, 'LimitMinToNull': false,  "ShowUnsmoothedValues":true
        };
        param.EditMode = false;

        me.vcVisual.addRampBaseByName('div', 'VISUAL_DATACENTER_SINGLE_EDIT','Source' + me.chartVcgid, getCurrentTimestamp(), me.visual.find('#divSource' + me.chartVcgid).height(), me.visual.find('#divSource' + me.chartVcgid).width(), JSON.stringify(param), JSON.stringify(signalParam), 1, function () {
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_GET_DATA', { 'target': 'Source' + me.chartVcgid, 'index': 0 });
        });

        return false;
    } catch (ex) {me.writeError('selectSignal', ex);return false;}
};

DCEdit.prototype.setSeriesIndex = function(series) {
    var me = this;
    try {
        me.visual.find('.legend .index').html('');
        for (var i = 0; i < series.length; i++) {
            me.visual.find('#bsaid' + series[i].options.guid + ' .index').html(i);
            me.visual.find('#color' + series[i].options.guid ).css('background-color', series[i].color);
        }
       
        if (me.editMode.seriesIndex > -1) {
            me.editMode.seriesIndex = 0;
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_GET_DATA', { 'target': me.chartVcgid, 'index': me.editMode.seriesIndex });
        }

        me.visual.find('#divLegend').removeClass('legend-loading');
        return false;
    } catch (ex) {me.writeError('setSeriesIndex', ex);return false;}
};

DCEdit.prototype.getLegendName = function(seriesIndex) {
    var me = this;
    try {
        return me.visual.find('.legend .index:contains(' + seriesIndex + ')').siblings('.caption').html();
    } catch (ex) { me.writeError('getLegendName', ex);  return me.resources.err_code; }
};

DCEdit.prototype.dismissChanges = function () {
    var me = this;
    try {
        me.showMessage(getCurrentTimestamp() + ' - ' + me.getLegendName(me.editMode.seriesIndex) + ' - ' + me.resources.changesDismissed, false);
        me.editMode.seriesIndex = -1;
        me.editMode.active = false;
        me.editMode.dirty = false;
        me.editMode.guid = -1;
        me.editMode.unplaus = -1;
        me.editMode.obplaus = -1;
        me.reload(-1);
        return false;
    } catch (ex) { me.writeError('dismissChanges', ex); return false;}
};

DCEdit.prototype.prepareSaveDialog = function () {
    var me = this;
    try {
        me.visual.find("#divSelection").hide();
// ReSharper disable once UnknownCssClass
        if (me.visual.find('#btnSave').hasClass("ui-button-disabled")) {
            if (me.editMode.seriesIndex > -1 && me.editMode.dirty === true) {
                alert(me.resources.err_EntryIsInvalid);
                return false;
            }
            me.editMode.seriesIndex = -1;
            me.reload(-1);
            me.showMessage('');
            return false;
        }
        return true;
    } catch (ex) {me.writeError('prepareSaveDialog', ex);return false;}
};

DCEdit.prototype.saveDialog = function() {
    var me = this;
    try {
        if (me.prepareSaveDialog() === false) {
            return false;}

        var dialog = $('<p>' + me.resources.saveChanges + '</p>').dialog({
            title: me.resources.saveDialogTitle,
            modal: true,
            buttons: {
                "Yes": function() {me.save();dialog.dialog('close');},
                "No": function() {me.dismissChanges();dialog.dialog('close');},
                "Cancel": function() {dialog.dialog('close');return false;}
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) {me.writeError('saveDialog', ex);return false;}
};

DCEdit.prototype.save = function() {
    var me = this;
    try {

        if (me.error) {
            return false;
        }
// ReSharper disable once UnknownCssClass
        if (me.visual.find('#btnSave').hasClass('ui-button-disabled')) {
            return false;
        }
        if (me.visual.find('.valbox input.invalid').length > 0) {
            alert(me.resources.err_invalidEntriesExist);
            return false;
        }

        var data = me.getEditList();

        if (data === null) {
            me.showMessage('ERROR on data list', true);
            return false;
        }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 0, 'data': data }),
            function(result) {
                if (result === false && data.valuelist.length > 0) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#divData").hide();
                me.visual.find("#divMenuUpdateSave,#divLog,#divCopy").hide();
                me.visual.find("#divInfo").show();
               
                me.visual.find('#divLegend #bsaid' + me.editMode.guid + ' .legend-edit').html('DONE');

                me.showMessage(getCurrentTimestamp() + ' - ' + me.getLegendName(me.editMode.seriesIndex) + ' - ' + me.resources.changesSaved, false);
                me.editMode.seriesIndex = -1;
                me.editMode.active = false;
                me.editMode.dirty = false;
                me.editMode.guid = -1;
                me.editMode.unplaus = -1;
                me.editMode.obplaus = -1;
                me.reload(-1);
                return false;
            });
        return false;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }
};

DCEdit.prototype.getEditList = function() {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var valEdit;
        var valData;
        var date = me.day;
        var bsaid = me.editMode.guid;
        var data = { 'bsaid': bsaid, 'day': date, 'valuelist': [] };

        for (var i = 0; i < 96; i++) {
            if (me.visual.find("#val" + (i + 1)).val().length > 0) {
                valEdit = me.visual.find("#val" + (i + 1)).val();
                valEdit = parseFloat(_vcC.cleanNumber(valEdit).replace(',', '.'));
            } else {
                valEdit = "";
            }
            if (me.visual.find("#val" + (i + 1)).data("old").length > 0) {
                valData = me.visual.find("#val" + (i + 1)).data("old");
                valData = parseFloat(_vcC.cleanNumber(valData).replace(',', '.'));
            } else {
                valData = "";
            }
        
            if (valData !== valEdit) {
                data.valuelist.push({ 'index': i + 1, 'valold': valData, 'valnew': valEdit });
            }

            
        }
        return data;

    } catch (ex) {
        
        me.writeError('showEditList', ex);
        return null;
    }
};

DCEdit.prototype.fillData = function(obj) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (obj.target === 'Source' + me.chartVcgid) {
            me.dataSource = obj.data;
            return false;
        }

        if (me.editMode.seriesIndex !== parseInt(obj.index, 10)) {
            me.showMessage(me.resources.err_wrongIndex, true);
            return false;
        }
        me.editMode.editData = obj.data;
        for (var i = 0; i < 96; i++) {
            if (me.editMode.editData[i] === null) {
                me.visual.find("#val" + (i + 1)).val('').addClass('empty').removeClass('inplaus');
                me.visual.find("#val" + (i + 1)).data("old", "");
            } else {
                me.visual.find("#val" + (i + 1)).removeClass('empty').val(Highcharts.numberFormat(me.editMode.editData[i], 3, ',', '.'));
                me.visual.find("#val" + (i + 1)).data("old", Highcharts.numberFormat(me.editMode.editData[i], 3, ',', '.'));
                if ((me.editMode.editData[i] >= me.editMode.unplaus)  && (me.editMode.editData[i] <= me.editMode.obplaus)) {
                    me.visual.find("#val" + (i + 1)).removeClass('inplaus');
                } else {
                    me.visual.find("#val" + (i + 1)).addClass('inplaus');
                }
            }

        }
        me.visual.find("#divData,#divMenuUpdateSave,#divCopy").show();

        me.visual.find('#btnSave').button('disable');
        me.visual.find("#divInfo,#divLog").hide();
        me.getSum();

        //open copy day chart
        me.initCopyChart();
       
        return false;
    } catch (ex) {
        me.writeError('fillData', ex);
        return false;
    }
};

DCEdit.prototype.editPoint = function(obj) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var row = obj.attr('id');
        row = parseInt(row.replace('val', ''), 10);
        row -= 1;
        var val = obj.val();
        if (me.validatePoint(obj)===false) {
            alert(me.resources.err_EntryIsInvalid);
            return false;
        }

        val = Number(val.replace(',', '.'),3);
        
        if (isNaN(val)) {
            obj.removeClass('invalid').addClass('invalid');
            me.visual.find('#btnSave').button('disable');
            alert(me.resources.err_EntryIsInvalid);
            return false;
        }

        me.getSum();
        _VCMQ.produce(me.visual, me.vcgid, 'RAMP_EDIT_SET_POINT', { 'target': me.chartVcgid, 'index': me.editMode.seriesIndex, 'row': row, 'val': val });
        return false;
    } catch (ex) {
        me.writeError('editPoint', ex);
        return false;
    }
};

DCEdit.prototype.validatePoint = function (obj) {
    var me = this;
    var bEmptyValue = false;
    try {
        if (me.error) {
            return false;
        }
        var row = obj.attr('id');
        row = parseInt(row.replace('val', ''), 10);
        row -= 1;
        var val = _vcC.cleanNumber(obj.val());
        //val = val.replace('.', '');
        if (val.length === 0) {
            if (me.editMode.editData[row] === null) {
                bEmptyValue = true;
            }
        }
        if ((validateNumeric(val) === false || isNaN(parseFloat(val))) && bEmptyValue === false) {
            obj.removeClass('invalid').addClass('invalid');
            me.visual.find('#btnSave').button('disable');
            return false;
        } else {
            if (bEmptyValue===false) {me.editMode.dirty = true;}
            obj.removeClass('invalid');
           
            val = _vcC.cleanNumber(val).replace(',', '.');
           
            if ((parseFloat(val) >= me.editMode.unplaus) && (parseFloat(val) <= me.editMode.obplaus)) {
                obj.removeClass('inplaus');
            } else {
               obj.addClass('inplaus');
            }
            if (me.visual.find('.valbox .invalid').length === 0 && bEmptyValue === false) {
                me.visual.find('#btnSave').button('enable');
            } else {
                return false;
            }

            return true;
        }
    } catch (ex) {
        me.writeError('validatePoint', ex);
        return false;
    }
};

DCEdit.prototype.markDoubleSettings = function () {
    var me = this;
    try {

     
        if (me.error) { return false; }
        me.visual.find("li.signallist .dims,li.signallist .korr").removeClass("multiplevalues");
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 3, 'loggerid': me.blid, 'day': me.day }),
            function (result) {
               
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result.rows === 0) { return false; }

                for (var i = 0; i < result.rows.length; i++) {
                    if (result.rows[i].dimscounter > 1) { me.visual.find('#unit' + result.rows[i].id).addClass("multiplevalues");}
                    if (result.rows[i].mkorrcounter > 1) {me.visual.find('#mkorr' + result.rows[i].id).addClass("multiplevalues");}
                    if (result.rows[i].skorrcounter > 1) {me.visual.find('#skorr' + result.rows[i].id).addClass("multiplevalues");}
                }
                return true;
            });
        return true;
    } catch (ex) { me.writeError('markDoubleSettings', ex); return false; }
};

DCEdit.prototype.setCurrentPlausibilities = function () {
    var me = this;

    var stmp = "";
    try {
        if (me.error) { return false; }
        me.visual.find("li.signallist .max,li.signallist .min").html("-").removeClass("inplaus");
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 4, 'loggerid': me.blid, 'day': me.day }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result.rows === 0) { return false; }
               
                me.dttMinMax = result;

                for (var i = 0; i < me.dttMinMax.rows.length; i++) {
             
                    if (me.dttMinMax.rows[i].minplaus === null || me.dttMinMax.rows[i].maxplaus === null) {
                        me.visual.find('#unplaus' + me.dttMinMax.rows[i].id).val(0);
                        me.visual.find('#obplaus' + me.dttMinMax.rows[i].id).val(0);
                        me.visual.find('#plaus' + me.dttMinMax.rows[i].id).html(me.resources.noPlausibilities).addClass("inplaus");

                    } else {
                        me.visual.find('#unplaus' + me.dttMinMax.rows[i].id).val(Highcharts.numberFormat(me.dttMinMax.rows[i].minplaus, 2, ',', '.'));
                        me.visual.find('#obplaus' + me.dttMinMax.rows[i].id).val(Highcharts.numberFormat(me.dttMinMax.rows[i].maxplaus, 2, ',', '.'));

                        stmp = "<div class='plausmin'>";
                        stmp += me.visual.find('#unplaus' + me.dttMinMax.rows[i].id).val();
                        stmp += "</div>";

                        stmp += "<div class='plaustype'>";
                         if (me.dttMinMax.rows[i].longterm !== null) {
                             stmp += "<i class='fa fa-clock'/> ";
                         }
                         if (me.dttMinMax.rows[i].reminds !== null) {
                             stmp += "<span class='icon-color-error'><i class='fa-regular fa-bell'/></span> ";
                         }

                        switch (me.dttMinMax.rows[i].saptid) {
                            case 122: stmp += "<br/>";
                                break;
                            case 124: stmp += "<i class='fa fa-power-off' title='" + me.resources.plausShutdown + "'/>";
                                break;
                            case 125: stmp += "<i class='fa-regular fa-exclamation-triangle  icon-color-error' title='" + me.resources.plausDisfunction + "'/>";
                                break;
                            case 126: stmp += "<i class='fa-regular fa-check-circle  icon-color-error' title='" + me.resources.plausOutlier + "' />";
                                break;
                            case 137: stmp += "<i class='fa fa-heartbeat  icon-color-ok' title='" + me.resources.plausConstControl + "'/>";
                                break;
                          
                            default:
                        }
                        stmp += "</div>";
                        stmp += "<div class='plausmax'>";
                        stmp += me.visual.find('#obplaus' + me.dttMinMax.rows[i].id).val();
                        stmp += "</div>";

                        me.visual.find('#plaus' + me.dttMinMax.rows[i].id).html(stmp).removeClass("inplaus");
                    }

                }

                return true;
            });
        return true;
    } catch (ex) { me.writeError('setCurrentPlausibilities', ex); return false; }
};

DCEdit.prototype.showValueEditorPopup = function (obj) {
    var me = this;
    var sVisualName = "";
    try {
        if (me.error) { return false; }

        switch (obj.type) {
            case 0: sVisualName = "VISUAL_DATACENTER_DIMS_EDITOR"; break;
            case 1: sVisualName = "VISUAL_DATACENTER_MKORR_EDITOR"; break;
            case 2: sVisualName = "VISUAL_DATACENTER_SKORR_EDITOR"; break;
            default: break;
        }
        showModalPopup( "<div id='divValueEditor1'></div>", 655, 810);
        me.vcVisual.addVisualBaseByName('divValue', sVisualName, 'Editor1', getCurrentTimestamp(), 780, 650, JSON.stringify(obj), '', 1);

        return true;
    } catch (ex) { me.writeError('showValueEditorPopup', ex); return false; }
};

DCEdit.prototype.showEditDetailForm = function (obj) {
    var me = this;
    var param;
    try {

        //hideWhileEditPlaus'
        if (me.error) {return false;}
        var id = $(obj).attr("data-id");

        if (me.visual.find("#divEditPlaus").is(":visible")) {
            me.hideEditDetailForm();
        } else {

            me.visual.find(".btnShowRules[data-id=" + id + "],.btnEditPlaus[data-id=" + id + "]").hide();
            me.visual.find(".btnEditDetailClose[data-id=" + id + "]").show();
            me.visual.find("#divSendTasks").hide();
           // $(obj).removeClass("fa-plus").addClass("fa-minus");
           me.visual.find("#signallist").addClass("hideWhileEditPlaus");
            me.visual.find("#signallist li").not("#bsaid" + id).addClass("hideWhileEditPlaus");
            me.visual.find("#divEditPlaus").show();
          
            if ($(obj).hasClass("btnEditPlaus")) {
                param = { "bsaid": id, "loggerid": me.blid, "day": me.day };
               
                var container = me.getRandomIDContainerObj("divEditPlaus-", true);
                container.obj.height(me.visual.find("#divEditPlaus").height());
                me.visual.find("#divEditPlaus").html(container.obj);


                container.obj.SignalAnalogExtendedConfig({ invokeType: "addVisualBase", parameter: { bsaid: id, LoggerID: me.blid } });

            } else {
                param = { "bsaid": id, "loggerid": me.blid, EditMode: true, ShowValidationIcons: true, ShowHeader: false };
                me.vcVisual.addVisualBaseByName('divEditP', 'VISUAL_ANALOGSIGNALS_RULETHERMS', 'laus', me.day, parseInt(me.visual.find("#divEditPlaus").height(), 10), parseInt(me.visual.find("#divEditPlaus").width(), 10), JSON.stringify(param), '', 1);
            }
        }
        return true;
    } catch (ex) { me.writeError('showEditDetailForm', ex); return false; }
};

DCEdit.prototype.hideEditDetailForm = function () {
    var me = this;

    try {
        if (me.error) { return false; }
        if (me.visual.find("#divEditPlaus").is(":visible")) {
            me.visual.find("#divSendTasks").show();
            me.visual.find("#divEditPlaus").hide();
            me.visual.find("#signallist li").removeClass("hideWhileEditPlaus");
            me.visual.find("#signallist").removeClass("hideWhileEditPlaus");
            me.visual.find(".btnEditDetailClose").hide();
            me.visual.find(".btnShowRules,.btnEditPlaus").show();
            me.setCurrentPlausibilities();
        }
        return true;
    } catch (ex) { me.writeError('hideEditDetailForm', ex); return false; }
};

DCEdit.prototype.setDroppedPoint = function(p) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var i15Min = p.col + 1;

       me.visual.find("#val" + i15Min).val(_vcC.cleanNumber(p.val));
        //me.visual.find("#val" + i15Min).val(p.val);
        me.editMode.dirty = true;
        me.validatePoint(me.visual.find("#val" + i15Min));
        me.getSum();
        me.visual.find('#btnSave').button('enable');
        return true;
    } catch (ex) {
        me.writeError('setDroppedPoint', ex);
        return false;
    }
};

DCEdit.prototype.copyData = function () {
    var me = this;
  
    try {
        if (me.error) {
            return false;
        }
        if (me.dataSource === null) {
            return false;
        }
        if (me.editMode.editData === null) {
            return false;
        }

        var indexStart = parseInt(me.visual.find('#ddl15MinFrom').val(), 10);
        var indexEnd = parseInt(me.visual.find('#ddl15MinTo').val(), 10);
        var copyType = parseInt(me.visual.find('#ddlCopyType').val(), 10);
        var valuelist = [];
        me.getSum();

        for (var i = indexStart; i <= indexEnd; i++) {
            
            switch (copyType) {
                case 1:

                    if (me.editMode.editData[i - 1] === null && me.dataSource[i - 1] !== null) {              
                            me.visual.find("#val" + (i)).removeClass('empty').val(me.dataSource[i - 1].toString().replace(".", ","));
                            valuelist.push({ 'row': i - 1, 'val': me.dataSource[i - 1] });
                    }
                    break;
                case 2:
                    if (me.editMode.editData[i - 1] === 0 && me.dataSource[i - 1] !== null) {
                        me.visual.find("#val" + (i)).removeClass('empty').val(me.dataSource[i - 1].toString().replace(".", ","));
                        valuelist.push({ 'row': i - 1, 'val': me.dataSource[i - 1] });
                    }
                    break;
                case 3:
                    if ((me.editMode.editData[i - 1] === 0) || (me.editMode.editData[i - 1] === null) && me.dataSource[i - 1] !== null ) {
                        me.visual.find("#val" + (i)).removeClass('empty').val(me.dataSource[i - 1].toString().replace(".", ","));
                        valuelist.push({ 'row': i - 1, 'val': me.dataSource[i - 1] });
                    }
                    break;
                case 4:
                    if ( me.dataSource[i - 1] !== null) {        
                        me.visual.find("#val" + (i)).removeClass('empty').val(me.dataSource[i - 1].toString().replace(".", ","));
                        valuelist.push({ 'row': i - 1, 'val': me.dataSource[i - 1] });
                        break;
                    }
                case 5:
                    me.visual.find("#val" + (i)).removeClass('empty').val(0);
                    valuelist.push({ 'row': i - 1, 'val': 0 });
                    break;
                case 6:
                    if (me.editMode.editData[i - 1] === null) {
                        me.visual.find("#val" + (i)).removeClass('empty').val(0);
                        valuelist.push({ 'row': i - 1, 'val': 0 });
                    }
                    break;
            }


        }
        _VCMQ.produce(me.visual, me.vcgid, 'RAMP_EDIT_SET_MULTIPLEPOINTS', { 'target':me.chartVcgid, 'index': me.editMode.seriesIndex, 'valuelist': valuelist });
        me.editMode.dirty = true;
        me.getSum();
        me.visual.find('#divInfo').hide(0);
        me.visual.find('#btnSave').button('enable');
        me.visual.find("#divMenuUpdateSave").show();
        return false;
    } catch (ex) {
        me.writeError('copyValues', ex);
        return false;
    }
};

DCEdit.prototype.sendTasks = function () {
    var me = this;
    var counter;
    var lst;
    try {

        if (me.error) { return false;}
       
        var dates = me.visual.find('#vc-cal-tasks').vcDate('getDate');
       
        if (me.visual.find('#ddlSendTask').val() === "delData") {
            lst = me.visual.find("li.signallist.selected");
        } else {
            lst = me.visual.find("li.signallist.selected").not(".rule");
        }
       counter =lst.length;
       if (confirm(me.resources.shouldTaskGetSendToSignals_rpl.replace("[_]", counter), 'Validation') === false) {
            return false;
        }

        var task = { 'BsaidList': [], 'StartDate': dates.from, 'EndDate': dates.to, 'TaskType': me.visual.find('#ddlSendTask').val() };
        var id;



        lst.each(function () {
            id = $(this).attr('id');
            id = parseInt(id.replace('bsaid', ''), 10);
            task.BsaidList.push(id);
        });
        
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 1, 'task': task }),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('sendTasks', ex);
        return false;
    }
};

DCEdit.prototype.getSum = function() {
    var me = this;
    var i;
    try {
        if (me.error) {
            return false;
        }
        var sumChart = 0;
        var val;

        
        for (i = 0; i < 96; i++) {
            if (me.editMode.editData[i] !== null) {
                sumChart += me.editMode.editData[i];
            }
        }
        var sum = 0;
        for (i = 0; i < 96; i++) {
            if (me.visual.find("#val" + (i + 1)).val().length > 0) {
                val = me.visual.find("#val" + (i + 1)).val();
                val = val.replaceAll('.', '').replace(',', '.');
                sum += parseFloat(val);
            }
        }

        sum = parseFloat(sum).toFixed(3);
        sumChart = parseFloat(sumChart).toFixed(3);
 
        var text = me.resources.save + " (Dif: " + Highcharts.numberFormat(parseFloat(sum) - parseFloat(sumChart), 3, ',', ' ') + ")";
        me.visual.find("#btnSave").button("option", "label", text);
       
        return sum;
    } catch (ex) {
        me.writeError('getSum', ex);
        return -999999;
    }
};


//end edit mode
//-------------

DCEdit.prototype.showTooltip = function(obj) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (obj.tooltip === null) {
            me.visual.find('#divTooltip').html('');
            return false;
        }

        var p = obj.tooltip.series.name.n + ', <u>' + obj.tooltip.point.category + ' ' + me.resources.clock + '</u>: <b>' + Highcharts.numberFormat(obj.tooltip.y, 2, ',', '.') + '</b> ';
        p = '<div>' + p + '</div>';
        me.visual.find('#divTooltip').html(p);
        return false;

    } catch (ex) {
        me.writeError('showTooltip', ex);
        return false;
    }
};

DCEdit.prototype.hideOthers = function() {
    /// <summary>
    /// This function hides the div container for other visuals (interventions, single edit ...) and shows the main form again.<br/>
    /// </summary>
    var me = this;
    try {
        me.visual.find("#divMain").show();
        me.visual.find("#divOthers").hide();
        me.visual.find('.subform').removeClass('button-toggle-active');
        return true;
    } catch (ex) {
        writeError('DCEdit.JS.hideOthers', ex);
        return false;
    }
};

DCEdit.prototype.toggleSubForm = function (obj) {
    /// <summary>
    /// This function toogles the single edit form<br/>
    /// </summary>
    var me = this;
    var id;
    var visualname="";
    var sParameter = "";
    var sDate;
    try {
        if (me.error) {
            return false;
        }

        me.visual.find("#divOthers").height($(".DCEdit").height()-me.visual.find("#divMenu").height()-30);
        

        if (obj.hasClass("button-toggle-active")) {
            me.hideOthers();
        } else {
            me.hideOthers();
            obj.addClass('button-toggle-active');
            //me.visual.find('#btnShowInterventions,#btnSingleEditDay,#btnRangeEditDay').removeClass('isOpen button-toggle-active');
            me.visual.find("#divMain, #divSelection").hide();
            me.visual.find("#divOthers").html(me.vcC.getLoadingIcon()).show();
            var param = { 'loggerid': me.blid, 'day': me.day, 'bsaid': [] };

            me.visual.find('#signallist .selected').not(".rule").each(function () {
                id = $(this).attr('id');
                id = parseInt(id.replace('bsaid', ''), 10);
                param.bsaid.push(id);
            });

          

            sDate = getCurrentTimestamp();

            switch (obj.attr("data-type")) {
                case "multiplaus":
                    //param.loggerid = me.blid;
                    param.bsaid = [];
                    me.visual.find('#signallist .selected').each(function () {
                        id = $(this).attr('id');
                        id = parseInt(id.replace('bsaid', ''), 10);
                        param.bsaid.push(id);
                    });
                    visualname = "VISUAL_DATACENTER_MULTI_PLAUS";
                    sParameter = JSON.stringify(param);
                    break;
                case "alarm":
                    visualname = "VISUAL_ALARMHISTORY";
                    sParameter = JSON.stringify({ 'loggerid': me.blid, 'startDate': me.day, 'endDate': me.day,'AllProjects':false,'ShowCurrentAlarms':false,"FixedContentHeight":true });
                    break;
                case "archiveStatus":
                    visualname = "VISUAL_DATACENTER_ARCHIVESTATUS";
                    sParameter = JSON.stringify(param);
                     
                    break;
                case 'singleEdit':
                    visualname = "VISUAL_DATACENTER_SPLIT_PEAKS";
                    sParameter = JSON.stringify(param);
                    break;
                case 'rangeEdit':
                    visualname = "VISUAL_DATACENTER_EDIT_RANGE";
                    sParameter = JSON.stringify(param);
                    break;
                case 'intervention':
                    visualname = "VISUAL_FORM_INTERVENTION";
                    sParameter = 'true,-1,' + me.blid;
                    sDate = me.day;
                  
                    break;
                case "archiveExport":


                    var container = me.getRandomIDContainerObj("div-others-", true);
                    container.obj.height(me.visual.find("#divOthers").height());
                    me.visual.find("#divOthers").html(container.obj);

                    var idList = [];
                    me.visual.find('#signallist .selected').not(".rule").each(function () {
                        id = $(this).attr('id');
                        id = parseInt(id.replace('bsaid', ''), 10);
                        idList.push(id);
                    });
                 
                    $("#div-others-" + container.random).ExportArchiveEmail({ invokeType: "addVisualBase", parameter: { LoggerId:me.blid, IDList: idList} });
                 
                    break;

                default: break;
            }
            if (visualname.length === 0) { return false }
            me.vcVisual.setShowFullscreen(false);
            me.vcVisual.setShowHeaderMenu(false);

           
            me.vcVisual.addVisualBaseByName("divOth", visualname, 'ers', sDate, parseInt(me.visual.find("#divOthers").height(), 10) - 10, parseInt(me.visual.find("#divOthers").width(), 10) - 5, sParameter, '', 1);
        }
        return true;
    } catch (ex) {
        writeError('DCEdit.JS.toggleSubform', ex);
        return false;
    }
};

DCEdit.prototype.showMessage = function(content, bError) {

    var me = this;
    try {
      
        me.visual.find("#divData,#divLog,#divMenuUpdateSave,#divCopy").hide();
        me.visual.find("#divInfo").show();
        if (content.length === 0) {
            me.visual.find('#divInfo').hide(0);
            return false;
        }
        if (bError) {
         
            me.error = true;
            me.visual.find('#divInfo div').removeClass('note').addClass('error');
            content = "<span class='main'>" + content + "</span><br/><span class='sub'>" + me.resources.err_sub + "</span>";
            me.visual.find('#divInfo div').html(content);
            //me.visual.find('#btnReload').button('disable');
            me.visual.find('#divSelection,#divOthers,.legend,#div' + me.vcgid + me.chartVcgid).hide();
        } else {
            me.visual.find('#divInfo div').removeClass('error').addClass('note').html(content);
        }

        return false;

    } catch (ex) {
        me.error = true;
        writeError('DCEdit.JS.showMessage', ex);
        return false;
    }
};




function DCSingleEdit() { }
DCSingleEdit.prototype = new DC();

// ReSharper disable once UnusedParameter
DCSingleEdit.prototype.doEvent = function (event) { return false; };

DCSingleEdit.prototype.init = function () {
    var me = this;
    try {
        //adjust height of list
        me.visual.find('#divList').height(me.height  - 20);

        me.visual.find("#divList").off('keyup').on('keyup', '.val', function () {
            var id = $(this).attr('id');
            id = id.replace('txtVal', '');

            if (validateNumeric($(this).val()) === false || isNaN(parseFloat($(this).val()))) {
                $(this).removeClass('invalid').addClass('invalid');
                me.visual.find('#list #btnSave' + id).hide();
                return false;
            } else {
                $(this).removeClass('invalid');
                me.visual.find('#list #btnSave' + id).show();
                return false;
            }
        });

        me.visual.find('#divList').off('click', '.save').on('click', '.save', function () {
            me.save($(this).attr('data-id'));
        });
        me.visual.find('#divList').off('click', '.saveZero').on('click', '.saveZero', function () {
            var id = $(this).attr('data-id');
            me.visual.find('#list #txtVal' + id).val('0');
            me.save(id);
        });
        me.visual.find('#divList').off('click', '.saveLast').on('click', '.saveLast', function () {
            var id = $(this).attr('data-id');
            me.visual.find('#list #txtVal' + id).val(me.visual.find('#list #txtPrev' + id).val());
            me.save(id);
        });

        me.visual.find('#divList').off('click', '.saveAvg').on('click', '.saveAvg', function () {
            var id = $(this).attr('data-id');
            var valPrev = me.visual.find('#list #txtPrev' + id).val();
            valPrev = parseFloat(valPrev.replaceAll('.', '').replace(',', '.'));
            var valNext = me.visual.find('#list #txtNext' + id).val();
            valNext = parseFloat(valNext.replaceAll('.', '').replace(',', '.'));
            var val = Highcharts.numberFormat((valPrev + valNext) / 2, 3, ',', '.');

            me.visual.find('#list #txtVal' + id).val(val);
            me.save(id);
        });
        me.visual.find('#divList').off('click', '.saveSplit').on('click', '.saveSplit', function () {
            var id = $(this).attr('data-id');
            var valNext = me.visual.find('#list #txtNext' + id).val();
            valNext = parseFloat(valNext.replaceAll('.', '').replace(',', '.'));
            var val = Highcharts.numberFormat(valNext / 2, 3, ',', '.');
            valNext = Highcharts.numberFormat(valNext, 3, ',', '.');
            me.visual.find('#list #txtNext' + id).val(val);
            me.visual.find('#list #txtVal' + id).val(val);
            me.save(id, valNext, parseFloat(val.replaceAll('.', '').replace(',', '.')));
        });

        me.visual.find('#list input').addClass('txtEnabled');
        me.visual.find('#list .prev, #list .next').prop('disabled', 'disabled').prop('readonly', 'readonly').formatDouble(3);
        me.visual.find('#list .icon,#list i').addClass('icon-color-info');

        return false;
    } catch (ex) {me.writeError('init', ex);return false;}
};

DCSingleEdit.prototype.save = function (id, valNextOld, valNextNew) {
    var me = this;
    try {

     
        if (me.error) {
            return false;
        }
        if (me.visual.find("#list #txtVal" + id).val().length === 0) {
            me.visual.find("#list #txtVal" + id).removeClass("invalid").addClass("invalid");
            return false;
        }

        var aID = id.split("_");
        var data = { 'bsaid': aID[0], 'day': me.day, 'valuelist': [] };
        var valEdit = me.visual.find("#list #txtVal" + id).val();
        valEdit = valEdit.replaceAll(".", "").replace(",", ".");
        valEdit = parseFloat(valEdit);
        data.valuelist.push({ 'index': parseInt(aID[1], 10), 'valold': "", 'valnew': valEdit });

        if (typeof (valNextOld) !== "undefined" && typeof (valNextNew) !== "undefined") {
            data.valuelist.push({ 'index': parseInt(aID[1]) + 1, 'valold': valNextOld, 'valnew': valNextNew });
        }

      

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify({ 'type': 0, 'data': data }),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#list #txtVal" + id).removeClass("invalid");
                me.visual.find("#list ." + id).css("opacity", 0.4);
                me.visual.find("#list #btnSave" + id + ",#list #btnSaveZero" + id + ",#list #btnSaveLast" + id + ",#list #btnSaveAvg" + id + ",#list #btnSaveSplit" + id).hide();

                return false;
            });
        return false;
    } catch (ex) {me.writeError("save", ex);return false;}
};



function DCMultipleValues() {
    this.bsaid = -1;
    this.counter = 0;
   
}
DCMultipleValues.prototype = new DC();

DCMultipleValues.prototype.initMultipleValues = function () {
    var me = this;
    try {

        me.showInfo("", "", false);


        me.visual.find(".vc-date").vcDate({ mode: "Range", align: "right", interval: 1, langID: me.userLangidForCulture });



        me.visual.find('.btnShow').off('click').on('click', function () {
            var val = $(this).attr("data-id");
            if (me.visual.find('.divDays[data-id=' + val + ']').is(':visible') === false) {
                if (me.visual.find('.divDays[data-id=' + val + ']').html().length === 0) {
                    var obj = {};
                    obj.bsaid = me.bsaid;
                    obj.type = me.valueType;
                    me.getDays(obj, val);
                } else {
                    me.visual.find('.divDays[data-id=' + val + ']').show();
                }
            } else {
                me.visual.find('.divDays[data-id=' + val + ']').hide();
            }
        });


        me.visual.find('.divDays').on('click', '.btnEditSingle', function() {
            var id = parseInt($(this).attr('data-id'), 10);
            var dt = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', $(this).attr('data-date')));
            _VCMQ.produce(me.visual, me.vcgid, 'SELECT_SINGLE_SIGNAL', { 'id': id, 'day': dt });
            $("#mask,#modalPopup").hide();
            
        });

        me.visual.find('.divDays').on('click', '.btnChange', function () {
            $(this).siblings(".change").html(me.visual.find('#divChange').html());
            $(this).siblings(".btnSaveChange").show();
        });

        me.visual.find('.divDays').on('click', '.btnSaveChange', function () {
            var obj = me.getSaveValues(this);
            if (obj === null) {
                me.showMessage(me.resources.err_loadData, true);
                return false;
            }
            if (me.save(obj)) {
                $(this).hide();
            }
            return true;
        });

     
            me.visual.find('#btnSaveAll').button().off('click').on("click", function () { 

                me.showInfo("", "", false);

                var dates = me.visual.find('.vc-date').vcDate('getDate');
                //var start = dates.from;
                //var end = dates.to;
                var start = new Date($.datepicker.parseDate('dd.mm.yy', dates.from));
                var end = new Date($.datepicker.parseDate('dd.mm.yy', dates.to));

                if (start > end) {
                    me.showInfo(me.resources.startHigherAsEnd, "", true);
                    return true;
                }

                var obj = {};
                obj.bsaid = me.bsaid;
                obj.type = me.valueType;

                //change dims
                if (me.valueType === "0") {
                   // obj.oldVal = ;
                    obj.newVal = me.visual.find('.change-all #ddl-dims-multiple-change option:selected').val();
                  
                    if (obj.newVal.length === 0) {
                       
                        me.showInfo(me.resources.valueEmpty, "", true);
                        return false;
                    }
                }

                //change mkorr/skorr
                if (me.valueType === "1" || me.valueType === "2") {
                    obj.newVal = me.visual.find('.change-all .value').val().replace('.', '').replace(',', '.');
                    if ($.isNumeric(obj.newVal) === false) {
                        me.visual.find('.change-all .value').removeClass("txtEnabled").addClass("formItemInvalid");
                        me.showInfo(me.resources.valueEmpty, "", true);
                      
                        return false;
                    }
                    if (typeof (me.visual.find('.change-all .chk')) !== "undefined") {
                        obj.ConvertValues = me.visual.find('.change-all .chk').prop('checked');
                    }
                }
               // me.visual.find('#txtSendTasksEnd').addClass("txtEnabled").removeClass("formItemInvalid");
               // me.visual.find('#txtSendTasksStart').addClass("txtEnabled").removeClass("formItemInvalid");
                me.visual.find('.change-all .value').addClass("txtEnabled").removeClass("formItemInvalid");
 
                me.counter = 0;
                me.error = false;

                while (start <= end) {
                   
                    obj.day = $.datepicker.formatDate('dd.mm.yy', new Date(start));
                    var newDate = start.setDate(start.getDate() + 1);
                    start = new Date(newDate);

                    me.counter += 1;
                   window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(obj),
                      function (result) {
                          if (result === null) {
                              me.showMessage(me.resources.err_saveData, true);
                              return false;
                          }
                          me.setCounter(false);
                          me.writeCounterInfo();

                          return result;
                    });         
                }
            return true;
        });



        return true;
    } catch (ex) { me.writeError('initMultipleValues', ex); return false; }
};

DCMultipleValues.prototype.setCounter = function (bAdd) {
    var me = this;
    try {
        if (me.error) { return false; }
       if (bAdd) {
           me.counter ++;
       } else {
           me.counter --;
       }
        return true;
    } catch (ex) {
        me.writeError('setCounter', ex);
        return false;
    }
};

DCMultipleValues.prototype.writeCounterInfo = function () {
    var me = this;
    try {
        if (me.error) { return false; }
        if (me.counter === 0) {
            me.showInfo("<b>" + me.resources.allChangesGetSent + "</b> ");
        } else {
            me.showInfo(me.counter + " " + me.resources.changesInProgress + " ");
        }
        return true;
    } catch (ex) {
        me.writeError('writeCounterInfo', ex);
        return false;
    }
};

DCMultipleValues.prototype.getDays = function (obj, val) {
    var me = this;
    try {
        if (me.error) {return false;}

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(obj), '', 1, 2, val,
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result.rows === 0) {
                    return false;
                }
                var sTmp = "";
                for (var i = 0; i < result.rows.length; i++) {
                    sTmp += "<div>";
                    sTmp += "<i class='btn btnEditSingle fa fa-edit icon-color-info' data-id='" + obj.bsaid + "' data-date='" + $.datepicker.formatDate('dd.mm.yy', result.rows[i].day) + "'></i>";
                    sTmp += " ";
                    sTmp += $.datepicker.formatDate('dd.mm.yy', result.rows[i].day);
                    sTmp += " <i class='btn btnChange fa fa-arrow-right icon-color-info' data-id='" + obj.bsaid + "' data-date='" + $.datepicker.formatDate('dd.mm.yy', result.rows[i].day) + "'></i>";
                    sTmp += " <span class='change'></span>";
                    sTmp += " <i class='btn btnSaveChange fa fa-save icon-color-info' data-id='" + obj.bsaid + "' data-date='" + $.datepicker.formatDate('dd.mm.yy', result.rows[i].day) + "' data-val='" + val + "'></i>";
                    sTmp += "</div>";
                }
                me.visual.find('.divDays[data-id=' + val + ']').html(sTmp).show();
               
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('getDays', ex);
        return false;
    }
};

DCMultipleValues.prototype.save = function (obj) {
    var me = this;
    try {
        if (me.error) { return false; }
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(obj),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                return result;
            });

        return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }
};

DCMultipleValues.prototype.showMessage = function (content, bError) {
    var me = this;
    try {
        if (bError === false) {
            console.info('got Log: ' + content);
        }
        if (bError) {
            me.writeError("DC.showMessage", content);
        }
        return true;
    } catch (ex) {
        writeError('DC.showMessage', ex);
        return false;
    }
};

DCMultipleValues.prototype.writeError = function (source, ex) {
    var me = this;
    try {
        me.error = true;


        writeError('DCMultipleValues.JS.' + source, ex);
        _VCMQ.produce(me.visual, me.vcgid, 'DC_ERROR', '');
        $("#mask,#modalPopup").hide();
       
        return true;
    } catch (ex) { writeError('DCMultipleValues.JS.writeError', ex); return false; }
};


function DCRangeEdit() { }
DCRangeEdit.prototype = new DC();

// ReSharper disable once UnusedParameter
DCRangeEdit.prototype.doEvent = function (event) { return false; };

DCRangeEdit.prototype.initMenu = function () {
    var me = this;
    try {
 
        me.visual.find("#vc-cal").vcDateBox({ mode: "Single", align: "center", interval: 1, langID: me.userLangidForCulture, defaultDate: me.defaultCopyDay });

        me.visual.find('#btnReload').button().off('click').on('click', function () { me.reload(); });
     
        return false;
    } catch (ex) { me.writeError('initMenu', ex); return false; }
};

DCRangeEdit.prototype.init = function () {
    var me = this;
    try {
        me.initMenu();
        me.setIndexRanges();
        //adjust height of list
        me.visual.find('#divList').height(parseInt(me.height - me.visual.find('#divMenu').height() - 20));
        me.visual.find('.val').addClass('txtEnabled');

        me.visual.find("#divList").off('keyup').on('keyup', '.val', function () {
            if (me.error) {
                return false;
            }
            if ($(this).val() !== $(this).attr("data-value")) {
                $(this).removeClass('dirty').addClass('dirty');
            } else {
                $(this).removeClass('dirty');
            }
            if (validateNumeric($(this).val()) === false || isNaN(parseFloat($(this).val()))) {
                $(this).removeClass('invalid').addClass('invalid');
            } else {
                $(this).removeClass('invalid');  
            }

            if (me.visual.find(".val.invalid").length === 0) {
                me.visual.find('#btnSave').button('enable');
            } else {
                me.visual.find('#btnSave').button('disable');
            }
            return true;
        });

        me.visual.find('#btnSave').button().off('click').on('click', function () {
            if (me.error) {
                return false;
            }
            if (me.visual.find(".val.dirty").length > 0) {
                me.saveDialog();
            }
            return true;
        }).button('disable');

        me.visual.find('#ddl15Min').off('change').on('change', function() {
            if (me.visual.find(".val.dirty").length > 0) {
                me.saveDialog();
            } else {
                me.reload();
            }
            me.setIndexRanges();
        });

        me.visual.find('#ddl15MinFrom,#ddl15MinTo').off('change').on('change', function () {
            me.showCopyRange();
        });

        me.visual.find('#btnCopy').button().off('click').on('click', function () {
            if (me.visual.find(".val").not(".notCopy").length === 0) {
                alert(me.resources.noEntriesSelected);
                return false;
            }
            me.fetchCopyValues();
            return true;
        });

        me.visual.find('#btnDel').button().off('click').on('click', function () {
          
            me.fetchDelValues();
            return true;
        });

        return false;
    } catch (ex) { me.writeError('init', ex);return false;}
};

DCRangeEdit.prototype.setIndexRanges = function () {
    var me = this;
    var i;
    var startIndex;
    var endIndex;
    try {
        startIndex = parseInt(me.visual.find('#ddl15Min').val(), 10);
        endIndex = startIndex + me.archiveRange - 1;
        me.visual.find('#ddl15MinFrom').val(startIndex);
        for (i = 1; i <= 96; i++) {
            if ((i < startIndex) || (i > endIndex)) {
                me.visual.find('#ddl15MinFrom option[value=' + i + ']').hide();
        } else {
            me.visual.find('#ddl15MinFrom option[value=' + i + ']').show();   
        }
    }

        if (endIndex > 96) {
            endIndex = 96; }
        me.visual.find('#ddl15MinTo').val(endIndex);
        for (i = 1; i <= 96; i++) {
            if ((i < startIndex) || (i > endIndex)) {
                me.visual.find('#ddl15MinTo option[value=' + i + ']').hide();
            } else {
                me.visual.find('#ddl15MinTo option[value=' + i + ']').show();
            }
        }
        return true;
    } catch (ex) { me.writeError('setIndexRanges', ex); return false; }
};

DCRangeEdit.prototype.showCopyRange = function () {
    var me = this;
    var i;
    var startIndex;
    var endIndex;
    try {
        startIndex = parseInt(me.visual.find('#ddl15MinFrom').val(), 10);
        endIndex = parseInt(me.visual.find('#ddl15MinTo').val(), 10);
        me.visual.find(".val").removeClass("notCopy");
        for (i = 1; i <=96; i++) {
           if (i<startIndex || i>endIndex) {
                me.visual.find(".val[data-index=" + i + "]").removeClass("notCopy").addClass("notCopy");
           }
        }

        return true;
    } catch (ex) { me.writeError('showCopyRange', ex); return false; }
};

DCRangeEdit.prototype.fetchCopyValues = function () {
    var me = this;
    var id;
    var startIndex;
    var endIndex;
    try {
        if (me.error) {
            return false;
        }
        startIndex = parseInt(me.visual.find("#ddl15MinFrom").val(), 10);
        endIndex = parseInt(me.visual.find("#ddl15MinTo").val(), 10);

        var dates = me.visual.find("#vc-cal").vcDateBox("getDate");
       
        var param = { 'loggerid': me.blid, 'day': dates.from, 'bsaid': [], 'archiveIndexStart': startIndex,'singleSignal': me.singleSignal, 'archiveRange': (endIndex - startIndex + 1) };

        me.visual.find(".colSignal").each(function () {
            id = parseInt($(this).attr("data-bsaid"), 10);
            if (isNaN(id) === false) { param.bsaid.push(id); }
        });
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(param), '', 1, 2, JSON.stringify({ 'type': 1 }),
            function (result) {
                if (result.length === 0) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
               
                return me.fillCopyValues(result);
            });
        return false;
    } catch (ex) {
        me.writeError('fetchCopyValues', ex);
        return false;
    }
};

DCRangeEdit.prototype.fetchDelValues = function () {
    var me = this;
    var id;
    var startIndex;
    var endIndex;
    var dataIndex;
    try {
        if (me.error) {
            return false;
        }


        startIndex = parseInt(me.visual.find("#ddlDelFrom").val(), 10);
        endIndex = parseInt(me.visual.find("#ddlDelTo").val(), 10);
      

        if (startIndex > endIndex) {
            alert(me.resources.startDateGreater);
            return false;
        }
        if (startIndex > 1) {
            dataIndex = startIndex - 1;
        } else {
            dataIndex = endIndex + 1;
        }
        if (dataIndex >96) {
            return false;
        }

       
        var valid = true;
        var list = me.visual.find(".colVal [data-index='" + (dataIndex) + "']");
        // console.info(list);
        for (var i = 0; i < list.length; i++) {
            if ($(list[i]).val().length === 0) {
                $(list[i]).removeClass('invalid').addClass('invalid');
              
                valid = false;
                  
            }
        }


        if (!valid) {
            $(list[i]).removeClass('invalid').addClass('invalid');
            dataIndex = endIndex + 1;
            var valid = true;
            var list = me.visual.find(".colVal [data-index='" + (dataIndex) + "']");
            // console.info(list);
            for (var i = 0; i < list.length; i++) {
                if ($(list[i]).val().length === 0) {
                    $(list[i]).removeClass('invalid').addClass('invalid');
                    alert(me.resources.missingValues);
                    valid = false;

                }
            }
        }

        if (!valid) { return false }


        var param = { 'loggerid': me.blid, 'day': me.day, 'bsaid': [], 'archiveIndexStart': startIndex,'DataIndexForDeleting':dataIndex, 'singleSignal': me.singleSignal, 'archiveRange': (endIndex - startIndex + 1) };

        me.visual.find(".colSignal").each(function () {
            id = parseInt($(this).attr("data-bsaid"), 10);
            if (isNaN(id) === false) { param.bsaid.push(id); }
        });

      
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(param), '', 1, 2, JSON.stringify({ 'type': 2 }),
            function (result) {
                if (result.length === 0) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                me.reload();
            });
        return false;
    } catch (ex) {
        me.writeError('fetchDelValues', ex);
        return false;
    }
};


DCRangeEdit.prototype.fillCopyValues = function (data) {
    var me = this;
    var startIndex;
    var i;
    var j;
    var counter;
    var list;
    var obj;
    try {
        if (me.error) {
            return false;
        }
        if (data.length === 0) {
            return false;
        }

        startIndex = parseInt(me.visual.find("#ddl15MinFrom").val(), 10);
        var copyType = parseInt(me.visual.find('#ddlCopyType').val(), 10);

        list = JSON.parse(data);


        for (i = 0; i < list.dataList.length; i++) {
            for (j = 0;j< list.dataList[i].values.length; j++) {

                counter = startIndex + j;
                obj = me.visual.find(".val[data-bsaid=" + list.dataList[i].bsaid + "][data-index=" + counter + "]");
               
                switch (copyType) {
                    case 1:
                        if (obj.val().length === 0) {
                            if (list.dataList[i].values[j].length > 0) {
                                obj.val(list.dataList[i].values[j]).removeClass("dirty").addClass("dirty");
                            }
                        }
                        break;
                    case 2:
                        if (parseInt(obj.val(),10) === 0) {
                            if (list.dataList[i].values[j].length > 0) {
                                obj.val(list.dataList[i].values[j]).removeClass("dirty").addClass("dirty");
                            }
                        }
                        break;
                    case 3:
                        if ((obj.val().length === 0) || (parseInt(obj.val(), 10) === 0)) {
                            if (list.dataList[i].values[j].length > 0) {
                                obj.val(list.dataList[i].values[j]).removeClass("dirty").addClass("dirty");
                            }
                        }
                        break;
                    case 4:
                        if (list.dataList[i].values[j].length > 0) {
                            obj.val(list.dataList[i].values[j]).removeClass("dirty").addClass("dirty");
                        }
                        break;
                    case 5:
                        obj.val("0,000").removeClass("dirty").addClass("dirty");
                        break;
                    case 6:
                        if (obj.val().length === 0) {
                            obj.val("0,000").removeClass("dirty").addClass("dirty");
                        }
                        break;
                }
            }
        }
        if (me.visual.find(".val.dirty").length>0) {
            me.visual.find('#btnSave').button('enable');
        }
        return true;
    } catch (ex) {
        me.writeError('fillCopyValues', ex);
        return false;
    }
};

DCRangeEdit.prototype.reload = function () {
    var me = this;
    var id;
    var startIndex;
    try {
        if (me.error) {
            return false;
        }

        startIndex = parseInt(me.visual.find("#ddl15Min").val(), 10);
        var param = { 'loggerid': me.blid, 'day': me.day, 'bsaid': [], 'singleSignal': me.singleSignal, 'archiveIndexStart': startIndex };
        
        me.visual.find(".colSignal").each(function () {
            id = parseInt($(this).attr("data-bsaid"), 10);
            if (isNaN(id) === false) {param.bsaid.push(id);}
        });
        me.visual.find('#divList').html(me.vcC.getLoadingIcon());

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(param), '', 1, 2, JSON.stringify({'type':0}),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                   return false;
                }
                me.visual.find('#divList').html(result);
                me.visual.find('.val').addClass('txtEnabled');
                me.visual.find('#btnSave').button('disable');
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};

DCRangeEdit.prototype.saveDialog = function () {
    var me = this;
    try {
       
        var dialog = $('<p>' + me.resources.saveChanges + '</p>').dialog({
            title: me.resources.saveDialogTitle, modal: true,
            buttons: {
                "Yes": function () { me.save(); dialog.dialog('close'); },
                "No": function () { me.reload(); dialog.dialog('close'); },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('saveDialog', ex); return false; }
};

DCRangeEdit.prototype.save = function () {
    var me = this;
    var signallist = [];
    var id;
    var index;
    var valuelist = [];
    var valOld;
    var valNew;
    try {

        if (me.error) { return false; }

        me.visual.find(".colSignal").each(function () {
            id = parseInt($(this).attr("data-bsaid"), 10);
            valuelist = [];
       
            me.visual.find(".val[data-bsaid=" + id + "]").each(function () {
                if ($(this).val() !== $(this).attr("data-value")) {
                    index = parseInt($(this).attr("data-index"),10);
                    valOld = $(this).attr("data-value");
                    valOld = valOld.replaceAll(".", "").replace(",", ".");
                    valOld = parseFloat(valOld);
                    valNew = $(this).val();
                    valNew = valNew.replaceAll(".", "").replace(",", ".");
                    valNew = parseFloat(valNew);
                    valuelist.push({ 'index': index, 'valold': valOld, 'valnew': valNew });
                }
            });
            if (valuelist.length > 0) {
                signallist.push({ 'bsaid': id, 'day': me.day, 'valuelist': valuelist });

            }

        });
     

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify(signallist ),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find('#btnSave').button('disable');

                me.visual.find(".val.dirty").each(function () {
                    $(this).attr("data-value", $(this).val());
                });
                me.visual.find(".val").removeClass('dirty').removeClass('notCopy');


                return false;
            });
        return false;
    } catch (ex) {me.writeError("save", ex);return false;}
};


function DCSignalTree() {} 
DCSignalTree.prototype = new vcTemplate();

DCSignalTree.prototype.init = function () {
  var me = this;
    try {

//init the button for showing the edit form
  me.visual.find('.btnEditDay').off('click').on('click',function() { 
   me.blid = $(this).attr('data-id');
//hide modal popup
  $('#mask, #modalPopup').hide();
   _VCMQ.produce(me.visual, me.vcgid, 'MANUAL_EDIT_DAY', {'loggerid':me.blid, 'day':me.day});
 }); 


    me.visual.find(".line:odd").addClass("alt");

    //init the button for showing the edit form
  me.visual.find('.btnPlaus').off('click').on('click', function () {
      var blid = $(this).attr('data-blid');
      var bsaid = $(this).attr('data-id');
      var param;

      if ($(this).hasClass("fa-plus")) {
          me.visual.find(".line").hide();
          $(this).parents(".line").show();
          me.visual.find("#divEditPlausSignalTree").show();


          $(this).removeClass("fa-plus").addClass("fa-minus");
        
          param = { "bsaid": bsaid, "loggerid": blid, "day": me.day };
          me.vcVisual.addVisualBaseByName('divEditPlaus', 'VISUAL_DATACENTER_PLAUS', 'SignalTree', getCurrentTimestamp(), parseInt(me.visual.find("#divEditPlausSignalTree").height(), 10), parseInt(me.visual.find("#divEditPlausSignalTree").width(), 10), JSON.stringify(param), '', 1);


      } else {
          me.visual.find("#divEditPlausSignalTree").html("").hide();
          me.visual.find(".line").show();
          $(this).removeClass("fa-minus").addClass("fa-plus");
      }

  });

 } catch (ex) { me.writeError('init', ex); }
};



function DCPlaus() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.Plausibility.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 7.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
DCPlaus.prototype = new vcTemplate();

DCPlaus.prototype.init = function () {
    /// <summary>
    /// Inits the form and the chart. <br/>
    /// </summary>   
    var me = this;
   
    try {

        me.visual.find("#divEditPlaus").html("");
        if (me.showToggleButton) {
            me.visual.find("#btn-toggle-plaus").off("click").on("click",
                function() {
                    if (me.visual.find("#div-plaus-details").is(":visible")) {
                        me.toggleDetails(false);
                        me.fetchSummary();
                    } else {
                        me.toggleDetails(true);
                    }

                }).button();
        } else {
            if (me.showCurrentPlaus) { me.fetchSummary(); }
        }


        if (me.showCurrentPlaus === false) {
            me.toggleDetails(true);
        } else {
            me.fetchSummary();
            me.visual.find("#div-plaus-details").hide();
        }
    
      

    } catch (ex) { me.writeError('init', ex); }
};

DCPlaus.prototype.fetchSummary = function () {
    /// <summary>
    /// Fetches the entry and decides if an entry exists (edit/delete) or not (add)<br/>
    /// </summary> 
    var me = this;
   
    try {

        if (me.error) { return false; }
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify({ "bsaid": me.bsaid, "day":me.day }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                me.visual.find("#div-plaus-summary").removeClass("error");
                if (result.id === null) {
                    me.visual.find("#div-plaus-summary").addClass("error").html(me.resources.noPlausibility);

                    _VCMQ.produce(me.visual, me.vcgid, 'OPEN_EDIT_CHART', { "minplaus": 0, "maxplaus": 0 });
                    return false;
                }

                _VCMQ.produce(me.visual, me.vcgid, 'OPEN_EDIT_CHART', {"minplaus":result.minplaus, "maxplaus":result.maxplaus  });

                me.visual.find("#div-plaus-summary").html("<b>" + moment(result.day).toDate().format("dd.MM.yyyy") + " - "  + result.plaus_type + "</b>");
                if (result.reminder !== null) {
                    me.visual.find("#div-plaus-summary").append(" (<i class='fa-regular fa-bell icon-color-error' /> " + moment(result.reminder).toDate().format("dd.MM.yyyy") + ")");
                }
                me.visual.find("#div-plaus-summary").append("<br/>Min./Max.: " + result.minplaus + "/" + result.maxplaus);
                
                if (result.description !== null) {
                   if (result.description.length >0) { me.visual.find("#div-plaus-summary").append(" (" + result.description + ")");}
                }

                return false;
            });
        return false;
    } catch (ex) { me.writeError("fetchSummary", ex); return false; }
};

DCPlaus.prototype.toggleDetails = function (bShow) {
    /// <summary>
    /// Inits the form and the chart. <br/>
    /// </summary>   
    var me = this;
    var signalParam = { 'series': [] };
    var param;
    try {

       if (bShow) {
           me.visual.find("#div-plaus-details").show();
        me.visual.find(".plaus-limit-chart").hide();
        me.visual.find('.plaus-form, .plaus-chart').html(me.vcC.getLoadingIcon()).show();
       
        param = { "bsaid": me.bsaid, "loggerid": me.blid, "day": me.day };
        me.vcVisual.addVisualBaseByName('divEditPlaus', 'VISUAL_FORM_DATACENTER_PLAUS', 'Form' + me.random, getCurrentTimestamp(), parseInt(me.visual.find(".plaus-form").height(), 10), parseInt(me.visual.find(".plaus-form").width(), 10), JSON.stringify(param), '', 1);
        
         
           if (me.showCharts) {

               param = {
                   'loggerID': me.blid,
                   'ShowInvalidValues': true,
                   'ShowPlotLines': true,
                   'datatype': 1,
                   'ShowIntervention': false,
                   'ShowEmptyChart': true,
                   'UseWidgetHeaderDate': true,
                   'AutoComparisonInterval': -1,
                   'ShowUnsmoothedValues': true,
                   'ShowExportIcons': false
               };
               signalParam.series.push({
                   'bsaid': [me.bsaid],
                   'rule': '[bsaid=' + me.bsaid + ']',
                   'ruleType': 1,
                   'guid': me.bsaid,
                   'edit': false
               });
              

               me.vcVisual.setShowFullscreen(false);
               me.vcVisual.setShowHeaderMenu(false);


               me.vcVisual.addRampByName('divEditPlaus',
                   'VISUAL_RAMP_SINGLE',
                   'Chart' + me.random,
                   me.day,
                   parseInt(me.visual.find('.plaus-chart').height(), 10),
                   parseInt(me.visual.find('.plaus-chart').width(), 10) - 50,
                   JSON.stringify(param),
                   JSON.stringify(signalParam),
                   1);
           } 
       } else {
           me.visual.find("#div-plaus-details").hide();
        }
    } catch (ex) { me.writeError('init', ex); }
};

DCPlaus.prototype.showPlausLimitChart = function (plausid) {
    /// <summary>
    /// opens the limit chart and hides the ramp chart <br/>
    /// </summary>     
    var me = this;
    var signalParam;
    try {
        if (me.error) { return false; }

        if (me.visual.find('#divEditPlausLimitsChart' + me.random).length ===0) {return true}


            me.visual.find(".plaus-chart").hide();
            me.visual.find('.plaus-limit-chart').show().html(me.vcC.getLoadingIcon());
            me.vcVisual.setShowFullscreen(false);
            me.vcVisual.setShowHeaderMenu(false);
            signalParam = { 'plausID': plausid };
      
        me.vcVisual.addRampByName('divEditPlaus', 'VISUAL_DATACENTER_PLAUS_LIMITS', 'LimitsChart' + me.random, me.day, parseInt(me.visual.find('#divEditPlausLimitsChart' + me.random).height(), 10), parseInt(me.visual.find('#divEditPlausLimitsChart' + me.random).width(), 10) - 50, "", JSON.stringify(signalParam), 1);
       
        return true;
    } catch (ex) { me.writeError('showPlausLimitChart', ex); return false; }
};

DCPlaus.prototype.doEvent = function (event) {
    /// <summary>
    /// inits the mq events. <br/>
    /// </summary>   
    var me = this;
    try {
        switch (event.msg) {
            case 'SHOW_PLAUSLIMIT_CHART':
                me.showPlausLimitChart(event.values.plausid); // me.showPlausLimitChart(event.values.plausid); break;
            default: break;
        }
        return false;
    } catch (ex) { me.writeError('doEvent', ex); return false; }
};



function DCLongTerm() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.LongTermValidation.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 25.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 25.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.alarmID = -1;
}
DCLongTerm.prototype = new vcTemplate();

DCLongTerm.prototype.init = function () {
    /// <summary>
    /// Inits the form buttons and input fields. <br/>
    /// </summary>   
    var me = this;
    try {

        
        me.visual.find("#btn-save").off("click").on("click", function() {
            me.save();
        }).button().button("option", "disabled", true);

        me.visual.find("#btn-delete").off("click").on("click", function () {
            me.delete();
        }).button();

        me.visual.find("#btn-new").off("click").on("click", function () {
            me.alarmID = -1;
            me.visual.find("#chb-active").prop("checked", true);
            me.visual.find("#txt-duration").val(1);
            me.visual.find("#div-data").show();
            me.visual.find("#div-new").hide();
            me.visual.find("#btn-delete").hide();
        }).button();

        me.visual.find("#chb-active").off("click").on("click", function() { me.validate();});
        me.visual.find("#txt-duration").off("keyup").on("keyup", function () { me.validate(); });

        me.fetchEntry();

    } catch (ex) { me.writeError('init', ex); }
};

DCLongTerm.prototype.validate = function () {
    /// <summary>
    /// Validates if the value of the duration input field is valid and enables/disables the save button<br/>
    /// </summary> 
    var me = this;
    var duration;
    var bValid = true;
    try {

        duration = me.visual.find("#txt-duration").val();
      
        if (duration.indexOf(".") > -1) { bValid = false }
        if (duration.indexOf(",") > -1) { bValid = false }
        if (isNaN(duration) === true) {bValid = false;}
        if (bValid) {
            me.visual.find("#btn-save").button("option", "disabled", false);
        } else {
            me.visual.find("#btn-save").button("option", "disabled", true);
        }
     
    } catch (ex) { me.writeError("fetchEntry", ex); }
};

DCLongTerm.prototype.fetchEntry = function () {
    /// <summary>
    /// Fetches the entry and decides if an entry exists (edit/delete) or not (add)<br/>
    /// </summary> 
    var me = this;
    var duration; 
    try {

        if (me.error) { return false; }

        
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify({"bsaid": me.bsaid}),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                if (result.rows === null) {
                    me.visual.find("#div-new").show();
                    me.visual.find("#div-data").hide();
                } else {
                    if (result.rows.length === 1) {
                        duration = result.rows[0].rule_interval;
                        duration = parseInt(duration.replace("D", ""),10);
                        me.alarmID = result.rows[0].id;
                        me.visual.find("#chb-active").prop("checked", result.rows[0].active);
                        me.visual.find("#txt-duration").val(duration);
                        me.visual.find("#div-new").hide();
                        me.visual.find("#div-data").show();
                        me.visual.find("#btn-delete").css("display", "inline-block");
                    }
                }

                return false;
            });
        return false;
    } catch (ex) { me.writeError("fetchEntry", ex); return false; }
};

DCLongTerm.prototype.save = function () {
    /// <summary>
    /// Simple saving and some show/display stuff<br/>
    /// </summary> 
    var me = this;
    var param;
    var duration;
    try {

        if (me.error) { return false; }

        duration = parseInt(me.visual.find("#txt-duration").val(),10);

        param = JSON.stringify({ "type":2,"bsaid": me.bsaid, "AlarmID": me.alarmID, "Active": me.visual.find("#chb-active").prop("checked"), "Duration": duration,"Delete": false
    });

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2,param,
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.alarmID = parseInt(result,10);
                me.visual.find("#btn-save").button("option", "disabled", true);
                me.visual.find("#btn-delete").css("display", "inline-block");

                return false;
            });
        return false;
    } catch (ex) { me.writeError("save", ex); return false; }
};

DCLongTerm.prototype.delete = function () {
    /// <summary>
    /// Simple deleting and some show/display stuff<br/>
    /// </summary> 
    var me = this;
    var param;
    try {

        if (me.error) { return false; }
        param = JSON.stringify({ "type": 2, "bsaid": me.bsaid, "AlarmID": me.alarmID,  "Delete": true});

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, param,
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.alarmID = -1;
                me.visual.find("#div-new").show();
                me.visual.find("#div-data").hide();

                return false;
            });
        return false;
    } catch (ex) { me.writeError("delete", ex); return false; }
};

DCLongTerm.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#div-new,#div-data").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};



function DCMultiPlaus() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.MultiPlaus.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 12.3.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 3.9.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - has full functionality now                                       *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 8.5.2018                                                *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.plausEditType = 0; // defines - add (0) or update(1) entries
    this.selectedEntries = {}; //helper list for reselecting entries after reload
    this.bInit = true; //helper flag for minifying initial relaoding 
}

DCMultiPlaus.prototype = new DC();

// ReSharper disable once UnusedParameter
DCMultiPlaus.prototype.doEvent = function (event) { return false; };

DCMultiPlaus.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
    var me = this;
    try {

        me.visual.css("height", me.height);
     
        me.visual.find("#divInfo").hide();
        //reset the height
        me.visual.find('#div-list .vc-list-table').css("max-height", me.height - me.visual.find('#div-menu').height() - me.visual.find('.vc-list-header').height() - 30);

        me.visual.find('.val').addClass('txtEnabled');

        //init the plaus type box 
        me.visual.find("#vc-box-plaus-type").vcOptionBox({
            caption: me.resources.plausibilities,
            items: [
            { button: me.resources.new, clickable: true, isList: false, funct:function() {me.togglePlausType()}, content:
                "<div id ='vc-date-interval' ></div></div><div class='note'>" + me.resources.infoNewPlaus + "</div></div>"
            },
            {button: me.resources.edit, clickable: true, isList: false, funct:function() {me.togglePlausType()}, content:
            "<div id ='vc-date-plaus-edit' ></div></div><div class='note'>" + me.resources.infoExistingPlaus + "</div></div>"
            }]
        });
        me.visual.find('.chb-plaus-type').off("click").on('click', function () { me.togglePlausType(); });
        me.togglePlausType();

        //inits the option box for diverse functionality
        me.visual.find("#vc-box-more").vcOptionBox({caption: me.resources.others,
            items: [
            {
                button: me.resources.plausibilities, clickable: true,isList: false,content:
                    "<div class='vc-grid-2col ' style='margin-right:15px'><div  id='div-btn-stop' class='vc-grid-2col' >" +
                         me.resources.stopSelectedPlaus + "</div><div style='clear:both'></div><div id ='vc-date-plaus-stop' ></div></div>" +
                       "<div class='vc-grid-2col'><div  id='div-btn-del' class='vc-grid-2col' >" + me.resources.deleteSelectedPlaus + "</div>" +
                        "<div style='clear:both'></div><div id ='vc-date-plaus-del' ></div></div>"
            },
            {
                button: me.resources.reminders, clickable: true, isList: false, content:
                "<div class='vc-grid-2col ' style='margin-right:15px'><div  id='div-btn-add-reminder' class='vc-grid-2col' >" +
                me.resources.saveReminders  + "</div><div style='clear:both'></div><div id ='vc-date-reminder' ></div></div>" +
                "<div class='vc-grid-2col'><div  id='div-btn-del-reminder' class='vc-grid-2col' >" + me.resources.deleteAllReminders +"</div>" +
                "<div class='note'>" + me.resources.infoDeleteReminders + "</div></div>"
            }
            ]
        });

        //inits the different vc-dates
        me.visual.find("#vc-date-interval").vcDate({ mode: "Range", align: "right", defaultRange: { from: me.day, to: me.day }, interval: 1, langID: me.userLangidForCulture, callback: function () { me.reload(); } });
        me.visual.find("#vc-date-plaus-edit").vcDate({ mode: "Single", align: "center", interval: 1, defaultDate: me.day, langID: me.userLangidForCulture, callback: function () { me.reload();}});
        me.visual.find("#vc-date-plaus-stop").vcDate({ mode: "Single", align: "center", interval: 1, langID: me.userLangidForCulture });
        me.visual.find("#vc-date-plaus-del").vcDate({ mode: "Range", align: "left", interval: 1, langID: me.userLangidForCulture });
        me.visual.find("#vc-date-reminder").vcDate({ mode: "Single", align: "center", interval: 1, langID: me.userLangidForCulture});

        //add menu click handlers
        me.visual.find("#div-btn-del-reminder").off("click").on("click", function () { me.deleteReminders() }).button();
        me.visual.find("#div-btn-add-reminder").off("click").on("click", function () { me.addReminders() }).button();
        me.visual.find("#div-btn-refresh").off("click").on("click", function () { me.reload(); });
        me.visual.find("#div-btn-save").off("click").on("click", function () {
            if (me.visual.find(".vc-list-table.signals .txtMin").length === 0) {
                me.openInfoDialog(me.resources.noEntriesSelected, { at: 'center center-20%', of: window });return true;
            }
            var txt = me.getSavingOverview();
            if (txt === false) return true;
            me.openAskDialog(txt, { at: 'center center-30%', of: window }, function () { me.save() }, function () { me.reload(); }); return true;
        });

        me.visual.find("#div-btn-del").off("click").on("click", function () {
            me.openAskDialog(me.resources.shouldEntriesGetDeleted, { at: 'center center-20%', of: window }, function () { me.delete(); }, function () { me.reload(); });
        }).button();

        me.visual.find("#div-btn-stop").off("click").on("click", function () {
            me.openAskDialog(me.resources.shouldChangesGetApplied, { at: 'center center-20%', of: window }, function () { me.stop() }, function () { me.reload(); });
        }).button();

        //init the list events for the initial list
        me.initListEvents();
        me.visual.find(".vc-list-table").off("click", ".fa-chart-bar").on("click", ".fa-chart-bar", function (e) { me.toggleDetails($(e.target), 0); e.stopPropagation() });
        me.visual.find(".vc-list-table").off("click", ".fa-chart-line").on("click", ".fa-chart-line", function (e) { me.toggleDetails($(e.target), 1); e.stopPropagation() });
        me.visual.find(".vc-list-table").off("click", ".btn-edit-plaus").on("click", ".btn-edit-plaus", function (e) { me.toggleDetails($(e.target), 2); e.stopPropagation() });


        me.visual.find(".vc-list-table").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) { me.toggleSelection($(e.target)); e.stopPropagation() });

        me.visual.find('#chb-select-all').off("click").on('click', function () { me.selectAll(); });
        me.visual.find("#ddl-filter-saptid").off("change").on("change", function () { me.reload(); });

        me.visual.find("#div-plaus-list").off("click", ".vc-list-item").on("click", ".vc-list-item", function(e) {
            me.visual.find("#div-plaus-list .vc-list-item").removeClass("selected");
            $(e.target).addClass("selected");
            me.showPlausLimitChart($(e.target));
        });


        me.visual.find("#modal-waiting-text").css("top", parseInt(me.visual.find(".vc-list-table").position().top, 10) + 5);
        me.visual.find("#modal-waiting-text").width(parseInt(me.visual.find(".vc-list-table").width, 10)-50);

        me.bInit = false;

        return false;
    } catch (ex) { me.writeError('init', ex); return false; }
};

DCMultiPlaus.prototype.initListEvents = function () {
    /// <summary>
    /// This function inits event handlers of the data list.
    /// </summary>
    var me = this;
    try {
       
        me.visual.find(".vc-list-table .vc-list-item:even").addClass("alt");

        //validate input fields on every keyup
        me.visual.find('.txt').keyup(function () { me.validate($(this)); });
        me.visual.find('.txt').change(function () { me.validate($(this)); });

        return true;
    } catch (ex) { me.writeError('initListEvents', ex); return false; }
};

DCMultiPlaus.prototype.validate = function (obj) {
    /// <summary>
    /// This function validates the given input field and enables/disabled the save button.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (validateNotEmpty(obj.val()) === false) {
                obj.removeClass("invalid").addClass("invalid");
                me.visual.find("#div-btn-save").removeClass("active");
                return false;
            };
           
            if (validateNumeric(obj.val()) === false) {
                obj.removeClass("invalid").addClass("invalid");
                me.visual.find("#div-btn-save").removeClass("active");
                return false;
            };
            obj.removeClass("invalid dirty");
            obj.addClass("dirty");
            obj.css("font-weight", "bold");
            me.visual.find("#div-btn-save").removeClass("active").addClass("active");
            return true;
     
    } catch (ex) { me.writeError('validate', ex); return false; }
};

DCMultiPlaus.prototype.reload = function () {
    /// <summary>
    /// This function reloads the given data list.
    /// </summary>
    var me = this;
    var dates;
    try {
        if (me.error) {
            return false;
        }
        if (me.bInit) { return true }

        //store the selected entries in a list to reselect them after loading again
        me.selectedEntries = [];
        me.visual.find(".vc-list-item.selected").each(function() { me.selectedEntries.push($(this).data("id"));});

        me.visual.find("#div-list").show();
        me.visual.find(".div-event").html("").hide();

        if (me.plausEditType === 0) {
            dates = me.visual.find('#vc-date-interval').vcDate('getDate');
        } else {
            dates = me.visual.find('#vc-date-plaus-edit').vcDate('getDate');
        }
        me.parameter.day = dates.from;
        me.parameter.endday = dates.to;
        me.parameter.plausEditType = me.plausEditType;
        me.parameter.saptid = parseInt(me.visual.find("#ddl-filter-saptid").val(),10);

       
        me.parameter.IgnoreSaptIds = [];
        if (me.visual.find("#chb-ignore-saptid-124").prop("checked")) { me.parameter.IgnoreSaptIds.push(124) };
        if (me.visual.find("#chb-ignore-saptid-125").prop("checked")) { me.parameter.IgnoreSaptIds.push(125) };
        if (me.visual.find("#chb-ignore-saptid-126").prop("checked")) { me.parameter.IgnoreSaptIds.push(126) };
        me.visual.find(".div-date-range").html(dates.from + ' - ' + dates.to);
        me.visual.find(".div-date-current").html(dates.from);

        me.visual.find('.vc-list-table.signals').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify({ 'type': 0 }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                me.visual.find(".div-detail").hide();
                me.visual.find(".vc-list-table li").show();
                me.visual.find('.vc-list-table.signals').html(result);
                me.visual.find(".vc-list-item").removeClass("selected");
                me.visual.find(".vc-list-item .chb-multiplaus-selected").prop("checked", false);
                //reselect them
                for (var i = 0; i < me.selectedEntries.length; i++) {
                    me.visual.find(".vc-list-item[data-id='" + me.selectedEntries[i] + "']").addClass("selected");
                    me.visual.find(".vc-list-item[data-id='" + me.selectedEntries[i] + "']").find(".chb-multiplaus-selected").prop("checked", true);
                }        
                me.visual.find('#div-btn-save').removeClass('active').addClass('active');
                me.initListEvents();
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};

DCMultiPlaus.prototype.getSavingOverview = function () {
    /// <summary>
    /// This function generates on overview message before saving.
    /// </summary>
    var me = this;
    var dates;
    var counter = 0;
    var txt;
    try {

        if (me.error) { return false; }
        if (me.visual.find("#div-btn-save").hasClass("active") === false) { return false }

        me.visual.find(".vc-list-item.selected").each(function () {  
            if (me.plausEditType === 0) {
                counter ++;
            } else {
                if ($(this).find(".dirty").length > 0) {counter ++ }
            }
        });

        if (counter === 0) { return false }
        dates = me.visual.find('#vc-date-interval').vcDate('getDate');
        if (me.plausEditType === 0) {
            txt = "<span style='font-weight:bold;font-size:larger'>" + me.resources.saveNewPlausibilities + "</span>";
        } else {
            txt = "<span style='font-weight:bold;font-size:larger'>" + me.resources.editExistingPlausibilities + "</span>";
        }
       
        txt += "<br/><br/>&#9873 " + counter + " " + me.resources.signalsGetEdited + "!";
        txt += "<br/><br/>&#9873 Typ: <b>" + me.visual.find("#ddl-saptid  option:selected").text() + "</b>";
        if (me.plausEditType === 0) {
            if (me.visual.find("#chb-set-enddate").prop("checked")) {
                txt += "<br/><br/>&#9873 " + me.resources.validityPeriod + " <b>" + dates.from + " - " + dates.to + "</b>";
            } else {
                txt += "<br/><br/>&#9873 " + me.resources.validFrom + " <b>" + dates.from + "</b>";
            }
            if (me.visual.find("#chb-add-event").prop("checked")) {
                txt += "<br/><br/>&#9873 " + me.resources.newEventGetOpened;
            }
        }

        txt += "<br/><br/><b> " + me.resources.shouldChangesGetApplied + "</b>";
        return txt;
    } catch (ex) {
        me.writeError('getSavingOverview', ex);
        return false;
    }
};

DCMultiPlaus.prototype.save = function () {
    /// <summary>
    /// This function generates a list of all plausibility entries, sends them to the server and saves them.
    /// </summary>
    var me = this;
    var item;
    var min = 0;
    var max = 0;
    var param, saptid, description;
    var dates;
    var entry;
    try {
        if (me.error) { return false;}

        if (me.visual.find("#div-btn-save").hasClass("active")===false ) {return false}

        param = {type:0,values : []}
        saptid = parseInt(me.visual.find("#ddl-saptid").val(),10);
        description = me.visual.find("#txt-description").val();
        dates = me.visual.find('#vc-date-interval').vcDate('getDate');

        me.visual.find(".vc-list-item.selected").each(function() {
            item = $(this);
            min = item.find(".txtMin").val().toString().replace(/\./g, '').replace(/\ /g, '').replace(',', '.');
            max = item.find(".txtMax").val().toString().replace(/\./g, '').replace(/\ /g, '').replace(',', '.');
            if (me.plausEditType === 0) {

                entry = { "bsaid": item.data("id"), "day": dates.from, "saptid": saptid, "minplaus": min, "maxplaus": max, "description": description }
                //if we want to stop the plaus at that time - we add an end date
                if (me.visual.find("#chb-set-enddate").prop("checked")) { entry.endDate = dates.to;}
                param.values.push(entry);

            } else {
                if (item.find(".dirty").length > 0) {
                    param.values.push({ "bsaid": item.data("id"),"minplaus": min,"maxplaus": max,"lastPlausId": item.data("lastplausid")});
                }
            }
        });
      
        if (param.values.length === 0) { me.reload() }
        me.parameter.plausEditType = me.plausEditType;

        me.visual.find(".vc-list").css("opacity", 0.3);
        me.visual.find("#modal-waiting-text").show();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.visual.find("#modal-waiting-text").hide();
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find('#div-btn-save').removeClass('active');
                me.visual.find(".vc-list").css("opacity", 1);
                me.visual.find("#modal-waiting-text").hide();
                //if we added new plaus entries we can optionally add a new event as well
                if (me.visual.find("#chb-add-event").prop("checked") && me.plausEditType === 0) {
                    me.addEvent(param.values);
                } else {
                    me.reload();
                }
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }
};

DCMultiPlaus.prototype.stop = function () {
    /// <summary>
    /// This function generates a list of all selected latest plausibility entry id, sends them to the server and copies them to the selected date.
    /// </summary>
    var me = this;
    var item;
    var param;
    var dates;
    try {
        if (me.error) { return false; }

        param = { type: 4, values: [] }
        dates = me.visual.find('#vc-date-plaus-stop').vcDate('getDate');

        //this is the date we will add the new plausibility entries 
        param.EndDate = dates.from;

        me.visual.find(".vc-list-item.selected").each(function () {
            item = $(this);
            if (item.data("lastplausid").toString.length > 0) {
                param.values.push({ "lastPlausId": item.data("lastplausid") });
            }
        });

        if (param.values.length === 0) { me.reload() }

        me.visual.find(".vc-list").css("opacity", 0.3);
        me.visual.find("#modal-waiting-text").show();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.visual.find("#modal-waiting-text").hide();
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find('#div-btn-save').removeClass('active');
                me.visual.find(".vc-list").css("opacity", 1);
                me.visual.find("#modal-waiting-text").hide();
                me.reload();
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('stop', ex);
        return false;
    }
};

DCMultiPlaus.prototype.delete = function () {
    /// <summary>
    /// This function generates a list of entries, sends them to the server and deletes all found plausibility entries on the given date range.
    /// </summary>
    var me = this;
    var param;
    var dates;
    try {
        if (me.error) { return false; }

        dates = me.visual.find('#vc-date-plaus-del').vcDate('getDate');
        param = { type: 3, values: [], StartDate: dates.from, EndDate: dates.to }

        me.visual.find(".vc-list-item.selected").each(function () {
            param.values.push({ "bsaid": $(this).data("id") });
        });

        if (param.values.length === 0) { return true; }
        me.visual.find(".vc-list").css("opacity", 0.3);
        me.visual.find("#modal-waiting-text").show();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.visual.find("#modal-waiting-text").hide();
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#modal-waiting-text").hide();
                me.visual.find(".vc-list").css("opacity", 1);
                me.reload();

                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('delete', ex);
        return false;
    }
};

DCMultiPlaus.prototype.togglePlausType = function () {
    /// <summary>
    /// This function toggles between the add/update plausibility type.
    /// </summary>
    var me = this;
    var type;
    try {

        type = parseInt(me.visual.find("#vc-box-plaus-type").vcOptionBox("getIndex"));
       
        me.plausEditType = type;
        switch (type) {
            case 0:
                me.visual.find("#vc-date-plaus-edit,#note-plaus-edit").css("opacity", 0.3);
                me.visual.find("#vc-date-interval,#note-plaus-new").css("opacity", 1);
                me.visual.find("#div-new-plaus-settings").css("opacity", 1);
                break;
            case 1:
                me.visual.find("#vc-date-plaus-edit,#note-plaus-edit").css("opacity", 1);
                me.visual.find("#vc-date-interval,#note-plaus-new").css("opacity", 0.3);
                me.visual.find("#div-new-plaus-settings").css("opacity", 0.3);
                break;
        default:
        }

        me.reload();
        return false;
    } catch (ex) { me.writeError('togglePlausType', ex); return false; }
};

DCMultiPlaus.prototype.toggleSelection = function (obj) {
    /// <summary>
    /// This function toggles between selected/unselected list entries.
    /// </summary>
    var me = this;
    var li;
    try {
        //ignore input boxes
        if (obj.hasClass("txt")) {return false}
 
        li = obj.parents("li");
        if (li.hasClass('selected')) {
            li.removeClass('selected');
            li.find(".chb-multiplaus-selected").prop("checked", false);
        } else {
            li.addClass('selected');
            li.find(".chb-multiplaus-selected").prop("checked",true);
        }
        return false;
    } catch (ex) { me.writeError('toggleSelectionSignal', ex); return false; }
};

DCMultiPlaus.prototype.selectAll = function () {
    var me = this;
    try {
      
            if (me.visual.find('#chb-select-all').prop('checked')) {
                me.visual.find(".vc-list-item").removeClass('selected').addClass('selected');
                me.visual.find(".vc-list-item .chb-multiplaus-selected").prop("checked", true);
            } else {
                me.visual.find(".vc-list-item").removeClass('selected');
                me.visual.find(".vc-list-item .chb-multiplaus-selected").prop("checked", false);
            }
        
        return true;
    } catch (ex) { me.writeError('selectAllSelectionSignals', ex); return false; }
};

DCMultiPlaus.prototype.toggleDetails = function (obj, type) {
    /// <summary>
    /// This function shows/hides the details (plausibility chart or plaus form) for the given signal.
    /// </summary>
    var me = this;
   
    try {
        if (me.error) {
            return false;
        }
        if (me.visual.find(".div-detail").is(":visible")) {
            me.visual.find(".div-detail").hide();
           me.visual.find(".vc-list-table li").show();

        } else {

            if (parseInt(type) != 2) {
                me.visual.find(".vc-list-table li").hide();
                obj.parents("li").show();
                me.visual.find(".div-detail #div-plaus-list").html(me.resources.makeSelection);
                me.visual.find(".div-detail").show().removeClass("form-plaus");
            }


           switch (parseInt(type)) {
               case 0: //show chart

                   me.showChart(obj);
                   break;
               case 1: //show plaus limit charts
                   me.fetchPlausList(obj);
                   break;
               case 2: //show plausibility entries
                   me.visual.find(".div-detail").addClass("form-plaus");
                   me.showPlausForm(obj);
                   break;
           default:
           }

       }
        return true;
    } catch (ex) {
        me.writeError('toggleDetails', ex);
        return false;
    }
};

DCMultiPlaus.prototype.fetchPlausList = function (obj) {
    /// <summary>
    /// This function fetches a plausibility list for the given signal.
    /// </summary>
    var me = this;
    var item, firstItem = null;
    var lst = [];
    var bsaid;
    var sTmp;
    try {
        if (me.error) {
            return false;
        }

       bsaid= parseInt(obj.parents("li").data("id"),10);

       me.visual.find('.div-detail #div-plaus-list').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify({ 'type': 1, "bsaid": bsaid, "day":me.day }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
            if (result.rows === null) {
                me.visual.find(".div-detail #div-plaus-list").html("<div class='ui-corner-all ui-state-error' style='padding:5px;margin:3px:text-align:center'>" + me.resources.noEntriesExist + "</div>");
                me.showLimitChart({ 'bsaid': bsaid });
                return true;
            }
            //add entries for the plaus list
            for (var i = 0; i < result.rows.length; i++) {
                sTmp = result.rows[i].plaus_type_icon + "<br/>";
                sTmp += $.datepicker.formatDate('dd.mm.yy', result.rows[i].day);
                if (result.rows[i].enddate !== null) {
                    sTmp += " - " + $.datepicker.formatDate('dd.mm.yy', result.rows[i].enddate);
                }
                item = $("<li>").addClass("vc-list-item").data("id", result.rows[i].id).html(sTmp );
                lst.push(item);
                if (i === 0) {
                    firstItem = item;
                    item.addClass("selected");
                }
            }
            me.visual.find(".div-detail #div-plaus-list").html(lst);
            me.visual.find(".div-detail #div-plaus-list .vc-list-item").removeClass("alt");
            me.visual.find(".div-detail #div-plaus-list .vc-list-item:even").addClass("alt");
              
            if (firstItem !== null) {me.showPlausLimitChart(firstItem);} 

            return true;
            });
        return false;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};
           
DCMultiPlaus.prototype.showPlausLimitChart = function (obj) {
    /// <summary>
    /// Opens the plaus chart for the selected plausibility entry <br/>
    /// </summary>     
    var me = this;
    try {
        if (me.error) { return false; }
        me.showLimitChart({ 'plausID': parseInt(obj.data("id"),10) });
        return true;
    } catch (ex) { me.writeError('showPlausLimitChart', ex); return false; }
};

DCMultiPlaus.prototype.showLimitChart = function (signalParam) {
    /// <summary>
    /// Finally opens the limit chart <br/>
    /// </summary>     
    var me = this;
   
    try {
        if (me.error) { return false; }

        me.visual.find("#div-plaus").show();
        me.visual.find("#div-plaus-chart").css('width', '78%').html(me.vcC.getLoadingIcon());
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.vcVisual.addRampByName('div-plaus-', 'VISUAL_DATACENTER_PLAUS_LIMITS', 'chart', me.day, parseInt(me.visual.find('#div-plaus-chart').height(), 10), parseInt(me.visual.find('#div-plaus-chart').width(), 10) - 50, "", JSON.stringify(signalParam), 1);

        return true;
    } catch (ex) { me.writeError('showPlausLimitChart', ex); return false; }
};
           
DCMultiPlaus.prototype.showPlausForm = function (obj) {
    /// <summary>
    /// opens the limit chart and hides the ramp chart <br/>
    /// </summary>     
    var me = this;
    var bsaid;
    var param;
   
    try {
        if (me.error) { return false; }

        me.visual.find("#div-plaus").hide();
        me.visual.find("#div-plaus-chart").css('width', '100%').html(me.vcC.getLoadingIcon());
       
        bsaid= parseInt(obj.parents("li").data("id"),10);
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);

        param = { "bsaid": bsaid, "loggerid": me.blid, "day": me.day };

        var size = me.getPopupSize(0.97, 0.95);
        var w = size[0];
        var h = size[1];
      
        window.showModalPopup("<div id='divPlausPopup1' class='frame' ></div>", w, h);
        $("#modalPopup").css("z-index", 20000);        

        me.vcVisual.addVisualBaseByName('divPlausPo', 'VISUAL_DATACENTER_PLAUS', 'pup1', getCurrentTimestamp(), parseInt(h-10, 10), parseInt(w-20, 10), JSON.stringify(param), '', 1);

        return true;
    } catch (ex) { me.writeError('showPlausForm', ex); return false; }
};

DCMultiPlaus.prototype.showChart = function (obj) {
    /// <summary>
    /// opens the archive chart for the last 30 days (from end date) and hides the ramp chart <br/>
    /// </summary>     
    var me = this;
    var bsaid;
    var param;
    var signalParam = { 'series': [] };
    var dates;
    var from, to;
    try {
        if (me.error) { return false; }

        me.visual.find("#div-plaus").hide();
        me.visual.find("#div-plaus-chart").css('width', '100%').html(me.vcC.getLoadingIcon());

        bsaid= parseInt(obj.parents("li").data("id"),10);
        signalParam.series.push({ 'bsaid': [bsaid], 'rule': '[bsaid=' + bsaid + ']', 'ruleType': 1 });

        if (me.plausEditType === 0) {
            dates = me.visual.find('#vc-date-interval').vcDate('getDate');
            to = dates.to;
        } else {
            dates = me.visual.find('#vc-date-plaus-edit').vcDate('getDate');
            to = dates.to;
        }
        from = moment(to, "DD-MM-YYYY").add(-30, 'days');
    
        param = {
            'loggerID': me.blid, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'datatype': 1, 'startDate': from, 'endDate': to, 'NoZoom': false,
            'dateUserDef': true, 'ShowEmptyChart': true, 'ShowUnsmoothedValues': true,'HideNotAllowedIntervals': false, "ShowIntervention": true, 'UseSimpleBottomLegend': true
            
        };
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.vcVisual.addRampByName('div-plaus-',
            'VISUAL_RAMP_SINGLE',
            'chart',
            getCurrentTimestamp(),
            parseInt(me.visual.find("#div-plaus-chart").height(), 10),
            parseInt(me.visual.find("#div-plaus-chart").width(), 10),
            JSON.stringify(param),
            JSON.stringify(signalParam),
            1);
            //get all series indexes and series color



        return true;
    } catch (ex) { me.writeError('showChart', ex); return false; }
};

DCMultiPlaus.prototype.deleteReminders = function () {
    /// <summary>
    /// This function generates a list of all signals, sends them to the server and deletes all reminders of them.
    /// </summary>
    var me = this;
    var param;
    try {
        if (me.error) { return false; }

        param = { type: 1, values: [] }
        me.visual.find(".signals .vc-list-item.selected").each(function () { param.values.push({ "bsaid": $(this).data("id") }); });
        if (param.values.length === 0) { return true; }
        me.visual.find(".vc-list").css("opacity", 0.3);
        me.visual.find("#modal-waiting-text").show();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.visual.find("#modal-waiting-text").hide();
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#modal-waiting-text").hide();
                me.visual.find(".vc-list").css("opacity", 1);
                me.reload();
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('deleteReminders', ex);
        return false;
    }
};

DCMultiPlaus.prototype.addReminders = function () {
    /// <summary>
    /// This function generates a list of all signals, sends them to the server and adds reminders for them.
    /// </summary>
    var me = this;
    var param;
    try {
        if (me.error) { return false; }

        var dt = me.visual.find("#vc-date-reminder").vcDate("getDate");


        param = { type: 2, values: [] }
        me.visual.find(".signals .vc-list-item.selected").each(function () { param.values.push({ "bsaid": $(this).data("id"), "day": dt.from }); });
        if (param.values.length === 0) { return true; }
        me.visual.find(".vc-list").css("opacity", 0.3);
        me.visual.find("#modal-waiting-text").show();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.visual.find("#modal-waiting-text").hide();
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find(".vc-list").css("opacity", 1);
                me.visual.find("#modal-waiting-text").hide();
                me.reload();
                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('deleteReminders', ex);
        return false;
    }
};

DCMultiPlaus.prototype.addEvent = function (values) {
    /// <summary>
    /// Generates some information and opens the event form (interventions) with these settings as default value. <br/>
    /// </summary>     
    var me = this;
    var signals = [];
    var param;
    var dates;
    try {
        if (me.error) { return false; }

        me.visual.find("#div-list").hide();
        me.visual.find(".div-event").show();
        dates = me.visual.find('#vc-date-interval').vcDate('getDate');
        for (var i = 0; i < values.length; i++) {
            signals.push(values[i].bsaid);
        }

        param = { "StartDate": dates.from, "Signals": signals, "description": me.visual.find("#txt-description").val() }
        if (me.visual.find("#chb-set-enddate").prop("checked")) { param.endDate = dates.to; }
        //if we have an outlier, we end the event on the same day
        if (me.visual.find("#ddl-saptid").val() === me.saptid_outlier) { param.EndDate = me.day; }

        me.vcVisual.addVisualBaseByName("div-event",'VISUAL_FORM_INTERVENTION',
            me.vcgid, me.day, parseInt(me.visual.find(".div-event").height(), 10), parseInt(me.visual.find(".div-event").width(), 10), "true,-1," + me.blid,
            JSON.stringify(param), 1);

        return true;
    } catch (ex) { me.writeError('addEvent', ex); return false; }
};

DCMultiPlaus.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
           
            me.visual.find("#divMenu, .vc-list").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};




function DCEditMeterReadings() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.LongTermValidation.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 25.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 25.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.alarmID = -1;
}
DCEditMeterReadings.prototype = new vcTemplate();

DCEditMeterReadings.prototype.init = function () {
    /// <summary>
    /// Inits the form buttons and input fields. <br/>
    /// </summary>   
    var me = this;
    try {
        me.visual.find("#info").hide();

        me.visual.find("#div-date").vcDate({ mode: "Range", align: "right", interval: 1, langID: me.userLangidForCulture });
       

        me.visual.find("#div-btn-preview").button().off("click").on("click", function () { me.preview(); });
        me.visual.find("#div-btn-save").button().off("click").on("click", function () { me.save(); });

    } catch (ex) { me.writeError('init', ex); }
};

DCEditMeterReadings.prototype.preview = function () {
    /// <summary>
    /// Simple saving and some show/display stuff<br/>
    /// </summary> 
    var me = this;
    var param;
    var dates;
    try {

        if (me.error) { return false; }

        dates = me.visual.find("#div-date").vcDate("getDateRange");
        //datesEnd = me.visual.find("#div-date-end").vcDate("getDate");

        param = JSON.stringify({
            "type": 1,
            "bsaid": me.visual.find("#ddl-signal").val(),
            "StartDate": dates.from, "EndDate": dates.to, "ReadingDif": me.visual.find("#txt-reading-dif").val()
        });


        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, param,
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                //me.alarmID = parseInt(result, 10);
                //me.visual.find("#btn-save").button("option", "disabled", true);
                //me.visual.find("#btn-delete").css("display", "inline-block");

                return false;
            });
        return false;
    } catch (ex) { me.writeError("save", ex); return false; }
};

DCEditMeterReadings.prototype.save = function () {
    /// <summary>
    /// Simple saving and some show/display stuff<br/>
    /// </summary> 
    var me = this;
    var param;
    var dates;
    try {

        if (me.error) { return false; }

        dates = me.visual.find("#div-date").vcDate("getDateRange");
        //datesEnd = me.visual.find("#div-date-end").vcDate("getDate");

        param = JSON.stringify({
            "type": 1,
            "bsaid": me.visual.find("#ddl-signal").val(),
            "StartDate": dates.from, "EndDate": dates.to, "ReadingDif": me.visual.find("#txt-reading-dif").val()
        });


        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, param,
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                //me.alarmID = parseInt(result, 10);
                //me.visual.find("#btn-save").button("option", "disabled", true);
                //me.visual.find("#btn-delete").css("display", "inline-block");

                return false;
            });
        return false;
    } catch (ex) { me.writeError("save", ex); return false; }
};

DCEditMeterReadings.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
               me.visual.find("").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


function DCSplitPeaks() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.SplitPeaks.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 5.9.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.9.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
DCSplitPeaks.prototype = new DC();

// ReSharper disable once UnusedParameter
DCSplitPeaks.prototype.doEvent = function (event) { return false; };

DCSplitPeaks.prototype.init = function () {
    /// <summary>
    /// Inits the form, input fields and fetches the data. <br/>
    /// </summary>   
    var me = this;
    try {
        me.visual.find("#divInfo").hide();
        //adjust height of list
        me.visual.find('#list').css("max-height", parseInt(me.height - me.visual.find("#div-menu").height() - 30,10));





        //init the box with the filter input
        me.visual.find("#vc-box-filter").vcOptionBox({caption: me.resources.filter,
            items: [{
                button: me.resources.leakValue, clickable: false, isList: false, content: "<input id='txt-value' class='txtEnabled'/>"
            }]
        });

        var ddl = $("<select>");
        ddl.attr("id", "ddl-selection");
        ddl.addClass("ddl");
        ddl.append($("<option>", { value: 'fill-null', text: me.resources.fillNull }));
        ddl.append($("<option>", { value: 'copy-value', text: me.resources.copyValue }));
        ddl.append($("<option>", { value: 'split-value', text: me.resources.splitValue }));
        ddl.append($("<option>", { value: 'half-value', text: me.resources.halfValue }));


        //init the box with the filter input
        me.visual.find("#vc-box-selection").vcOptionBox({
            caption: me.resources.selection,
            items: [{
                button: me.resources.multiSelection, clickable: false, isList: true, content: ddl
            }]
        });

        me.visual.find("#div-btn-refresh").off("click").on("click", function () { me.reload(); });
        


        me.visual.find("#div-btn-save").off("click").on("click", function () {
            if (me.visual.find("." + me.visual.find("#ddl-selection").val() + ":visible").length === 0) {
                me.openInfoDialog(me.resources.noEntriesExist, { at: 'center center-20%', of: window }); return true;
            }
            var txt = "<b>" + me.resources.shouldAllPossibleEntriesGetChanged  + "</b><br/><br>" + me.resources.pleaseWaitForAllChangesGotSaved;
            me.openAskDialog(txt, { at: 'center center-30%', of: window }, function () { me.multiSave() }, function () { me.reload(); }); return true;
        });

        me.visual.find(".vc-list-table").off("click", ".fa-chart-bar").on("click", ".fa-chart-bar", function (e) { me.toggleDetails($(e.target)); e.stopPropagation() });
        me.visual.find(".vc-list-table").off("click", ".col6 .icon").on("click", ".col6 .icon", function (e) { me.save($(e.target)); e.stopPropagation() });

        me.reload();
        return false;
    } catch (ex) { me.writeError('init', ex); return false; }
};

DCSplitPeaks.prototype.multiSave = function () {
    /// <summary>
    ///Generates the update object and sends it to the server. The edit type is based on the clicked button <br/>
    /// </summary>   
    var me = this;
    try {

        if (me.error) {
            return false;
        }
        var filter = me.visual.find("#ddl-selection").val();
       
        me.visual.find("." + filter + ":visible").each(function() {
            me.save($(this));
        });



        return false;
    } catch (ex) { me.writeError("multiSave", ex); return false; }
};

DCSplitPeaks.prototype.save = function (obj) {
    /// <summary>
    ///Generates the update object and sends it to the server. The edit type is based on the clicked button <br/>
    /// </summary>   
    var me = this;
    var param = {};
    var li;
    var prevVal, curVal;
    try {

        if (me.error) {
            return false;
        }

        li = obj.parents("li");
     
        param.bsaid = li.data("id");
        param.StartDate = li.data("lastday");
        param.EndDate = me.day;

        //we have to move the date to the next day if we found a leak which ends at the next day 0:15h
        if (li.data("endofcurrentdaymissing")) {
            var nextDay = moment(param.EndDate, "DD-MM-YYYY").add(1, 'days');
            param.EndDate = nextDay.format("DD.MM.YYYY");
        }

       
        param.StartIndex = li.data("lastindex");
        param.EndIndex = li.data("index");
        param.OldValue = me.visual.find("#txt-value").val();

        param.EditType = obj.data("type");


        prevVal = parseFloat((li.data("lastvalue")+'').replaceAll('.', '').replaceAll(',', '.'));
        curVal = parseFloat((li.data("value") + "").replaceAll('.', '').replaceAll(',', '.'));
        switch (parseInt(param.EditType,10)) {
            case 0: //set 0 
                param.Value = 0; 
                param.Counts = li.data("counts");
                break;
            case 1: //fill with the current val  
                param.Value = curVal;
                param.Counts = li.data("counts");
                break;
            case 2: //split next value
                param.Counts = li.data("counts") + 1;
                param.EndIndex += 1;
                param.Value = (curVal / param.Counts);
                break;
            case 3: //average
                param.value = (curVal + prevVal) / 2;
                param.Counts = 1;
                break;
            case 4: //split zst to full day
                param.value = curVal;
                param.Counts = li.data("counts");
                param.ZstLeakIndexes = (li.data("zstindexes")+'').split(",").map(element => { return Number(element); });

                $.each(me.visual.find("#list .vc-list-item.go.leak"), function () {
                    if ($(this).data("id") == param.bsaid) { $(this).hide();}
                });

                break;
        default:
        }
     
        li.addClass("done");

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify(param),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    li.addClass("error");
                    return false;
                }
           
                if (me.visual.find("#div-detail").is(":visible")) {
                    me.toggleDetails(obj);
                }
                return false;
            });
        return false;
    } catch (ex) { me.writeError("save", ex); return false; }
};

DCSplitPeaks.prototype.reload = function () {
    /// <summary>
    /// This function reloads the given data list.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (me.bInit) { return true }

        me.visual.find("#div-detail").hide();

        me.visual.find('#list').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, 0, 0, me.parameter, '', 1, 2, JSON.stringify({ 'value': me.visual.find("#txt-value").val() }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
               
                me.visual.find('#list').html(result);
                //set the new tooltips for the buttons.
                me.visual.find(".col7 .vc-list-icon").attr("title", me.resources.archive);
                me.visual.find(".col6 .fill-null").attr("title", me.resources.fillNull);
                me.visual.find(".col6 .copy-value").attr("title", me.resources.copyValue);
                me.visual.find(".col6 .split-value").attr("title", me.resources.splitValue);
                me.visual.find(".col6 .half-value").attr("title", me.resources.halfValue);

                return true;
            });
        return false;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};

DCSplitPeaks.prototype.toggleDetails = function (obj) {
    /// <summary>
    /// This function shows/hides the details (plausibility chart or plaus form) for the given signal.
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
  
        var bsaid = parseInt(obj.parents("li").data("id"), 10);
        me.vcVisual.showRampArchiveSimplePopup({ Day: me.day, LoggerId: me.blid, PopupIdentifier: -1, SelectedBsaids: [bsaid] } );




        return true;
        //if (me.visual.find("#div-detail").is(":visible")) {
        //    me.visual.find("#div-detail").hide();
        //    me.visual.find(".vc-list-table li").show();
        //} else {
        //    me.visual.find(".vc-list-table li").hide();
        //    obj.parents("li").show();
        //    me.showChart(obj);
        //}
        //return true;
    } catch (ex) {
        me.writeError('toggleDetails', ex);
        return false;
    }
};

//DCSplitPeaks.prototype.showChart = function (obj) {
//    /// <summary>
//    /// opens the archive chart for the last 30 days (from end date) and hides the ramp chart <br/>
//    /// </summary>     
//    var me = this;
//    var bsaid;
//    var param;
//    var signalParam = { 'series': [] };

//    try {
//        if (me.error) { return false; }

//        me.visual.find("#div-detail").show().css('width', '100%').html(me.vcC.getLoadingIcon());
//        bsaid = parseInt(obj.parents("li").data("id"), 10);
//        signalParam.series.push({ 'bsaid': [bsaid], 'rule': '[bsaid=' + bsaid + ']', 'ruleType': 1 });

//        var start = moment(me.day, "DD.MM.YYYY"); //todays date
//        var end = moment(me.day, "DD.MM.YYYY");
//        var duration = moment.duration(start.diff(end));
//        var days = duration.asDays();
      
//        param = {
//            'loggerID': me.blid, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'datatype': 1, 'startDate': obj.parents("li").data("lastday"), 'endDate': me.day, 'NoZoom': false,
//            'dateUserDef': true, 'ShowEmptyChart': true,'ShowUnsmoothedValues':true, 'HideNotAllowedIntervals': false, "ShowIntervention": true, 'UseSimpleBottomLegend': true, 'UseWidgetHeaderDate':true, 'AutoDateUserDefInterval':days
//        };
//        me.vcVisual.setShowFullscreen(false);
//        me.vcVisual.setShowHeaderMenu(false);
//        me.vcVisual.addRampByName('div-', 'VISUAL_RAMP_SINGLE', 'detail',me.day,parseInt(me.visual.find("#div-detail").height(), 10), parseInt(me.visual.find("#div-detail").width(), 10), JSON.stringify(param),JSON.stringify(signalParam),1);


//        return true;
//    } catch (ex) { me.writeError('showChart', ex); return false; }
//};

DCSplitPeaks.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#div-menu, .vc-list").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};
